export const height = {
    0: {
        girl: [45.644, 47.217, 49.148, 51.078, 52.651],
        boy: [46.324, 47.922, 49.884, 51.846, 53.445],
    },
    1: {
        girl: [49.96, 51.609, 53.633, 55.657, 57.305],
        boy: [51.005, 52.648, 54.665, 56.681, 58.324],
    },
    2: {
        girl: [53.249, 54.969, 57.08, 59.19, 60.91],
        boy: [54.676, 56.365, 58.438, 60.512, 62.201],
    },
    3: {
        girl: [55.897, 57.676, 59.859, 62.042, 63.821],
        boy: [57.644, 59.371, 61.49, 63.61, 65.337],
    },
    4: {
        girl: [58.1, 59.93, 62.176, 64.422, 66.251],
        boy: [60.06, 61.818, 63.977, 66.135, 67.893],
    },
    5: {
        girl: [59.962, 61.836, 64.137, 66.438, 68.312],
        boy: [62.038, 63.822, 66.012, 68.202, 69.986],
    },
    6: {
        girl: [61.587, 63.504, 65.857, 68.21, 70.126],
        boy: [63.719, 65.528, 67.749, 69.97, 71.779],
    },
    7: {
        girl: [63.068, 65.027, 67.432, 69.837, 71.796],
        boy: [65.218, 67.053, 69.307, 71.56, 73.396],
    },
    8: {
        girl: [64.455, 66.456, 68.913, 71.37, 73.372],
        boy: [66.604, 68.469, 70.76, 73.05, 74.916],
    },
    9: {
        girl: [65.769, 67.814, 70.325, 72.836, 74.882],
        boy: [67.918, 69.816, 72.147, 74.478, 76.377],
    },
    10: {
        girl: [67.024, 69.115, 71.681, 74.247, 76.337],
        boy: [69.165, 71.1, 73.476, 75.851, 77.786],
    },
    11: {
        girl: [68.227, 70.363, 72.986, 75.609, 77.745],
        boy: [70.352, 72.326, 74.748, 77.171, 79.144],
    },
    12: {
        girl: [69.383, 71.566, 74.245, 76.925, 79.107],
        boy: [71.486, 73.5, 75.973, 78.445, 80.46],
    },
    13: {
        girl: [70.495, 72.725, 75.462, 78.2, 80.43],
        boy: [72.574, 74.631, 77.156, 79.682, 81.739],
    },
    14: {
        girl: [71.567, 73.844, 76.64, 79.435, 81.712],
        boy: [73.619, 75.72, 78.3, 80.88, 82.982],
    },
    15: {
        girl: [72.603, 74.928, 77.781, 80.633, 82.958],
        boy: [74.625, 76.773, 79.409, 82.045, 84.193],
    },
    16: {
        girl: [73.606, 75.978, 78.888, 81.799, 84.17],
        boy: [75.599, 77.793, 80.487, 83.18, 85.375],
    },
    17: {
        girl: [74.578, 76.997, 79.966, 82.934, 85.353],
        boy: [76.539, 78.782, 81.536, 84.289, 86.532],
    },
    18: {
        girl: [75.521, 77.987, 81.014, 84.04, 86.506],
        boy: [77.451, 79.743, 82.556, 85.37, 87.662],
    },
    19: {
        girl: [76.438, 78.951, 82.035, 85.118, 87.631],
        boy: [78.332, 80.674, 83.549, 86.424, 88.766],
    },
    20: {
        girl: [77.33, 79.889, 83.03, 86.171, 88.73],
        boy: [79.187, 81.58, 84.517, 87.454, 89.847],
    },
    21: {
        girl: [78.197, 80.803, 84.001, 87.2, 89.806],
        boy: [80.016, 82.461, 85.462, 88.462, 90.907],
    },
    22: {
        girl: [79.042, 81.694, 84.949, 88.204, 90.856],
        boy: [80.822, 83.319, 86.384, 89.448, 91.945],
    },
    23: {
        girl: [79.866, 82.563, 85.874, 89.185, 91.882],
        boy: [81.609, 84.158, 87.286, 90.415, 92.963],
    },
    24: {
        girl: [79.969, 82.711, 86.077, 89.443, 92.185],
        boy: [81.676, 84.277, 87.47, 90.663, 93.264],
    },
    25: {
        girl: [80.751, 83.539, 86.96, 90.381, 93.169],
        boy: [82.423, 85.076, 88.333, 91.589, 94.242],
    },
    26: {
        girl: [81.517, 84.348, 87.823, 91.298, 94.13],
        boy: [83.15, 85.854, 89.173, 92.492, 95.196],
    },
    27: {
        girl: [82.263, 85.138, 88.666, 92.195, 95.07],
        boy: [83.856, 86.611, 89.992, 93.373, 96.127],
    },
    28: {
        girl: [82.991, 85.909, 89.49, 93.071, 95.988],
        boy: [84.544, 87.347, 90.788, 94.229, 97.033],
    },
    29: {
        girl: [83.7, 86.66, 90.294, 93.928, 96.888],
        boy: [85.21, 88.062, 91.563, 95.063, 97.915],
    },
    30: {
        girl: [84.394, 87.396, 91.08, 94.764, 97.766],
        boy: [85.859, 88.758, 92.316, 95.874, 98.773],
    },
    31: {
        girl: [85.07, 88.113, 91.849, 95.584, 98.627],
        boy: [86.491, 89.435, 93.05, 96.664, 99.609],
    },
    32: {
        girl: [85.734, 88.817, 92.602, 96.386, 99.469],
        boy: [87.107, 90.096, 93.766, 97.435, 100.425],
    },
    33: {
        girl: [86.384, 89.507, 93.341, 97.175, 100.298],
        boy: [87.711, 90.744, 94.466, 98.189, 101.221],
    },
    34: {
        girl: [87.025, 90.187, 94.068, 97.949, 101.111],
        boy: [88.307, 91.38, 95.154, 98.927, 102.001],
    },
    35: {
        girl: [87.652, 90.854, 94.783, 98.713, 101.914],
        boy: [88.891, 92.006, 95.83, 99.654, 102.769],
    },
    36: {
        girl: [88.274, 91.512, 95.488, 99.464, 102.702],
        boy: [89.469, 92.623, 96.496, 100.368, 103.523],
    },
    37: {
        girl: [88.883, 92.16, 96.183, 100.205, 103.482],
        boy: [90.039, 93.232, 97.152, 101.072, 104.266],
    },
    38: {
        girl: [89.486, 92.8, 96.868, 100.936, 104.25],
        boy: [90.602, 93.833, 97.799, 101.766, 104.997],
    },
    39: {
        girl: [90.081, 93.431, 97.544, 101.657, 105.007],
        boy: [91.159, 94.427, 98.437, 102.448, 105.715],
    },
    40: {
        girl: [90.665, 94.053, 98.211, 102.369, 105.756],
        boy: [91.708, 95.012, 99.066, 103.121, 106.424],
    },
    41: {
        girl: [91.245, 94.667, 98.869, 103.07, 106.493],
        boy: [92.25, 95.588, 99.686, 103.783, 107.122],
    },
    42: {
        girl: [91.813, 95.272, 99.517, 103.763, 107.221],
        boy: [92.785, 96.157, 100.296, 104.435, 107.808],
    },
    43: {
        girl: [92.376, 95.869, 100.157, 104.446, 107.939],
        boy: [93.311, 96.717, 100.898, 105.079, 108.485],
    },
    44: {
        girl: [92.929, 96.458, 100.789, 105.12, 108.648],
        boy: [93.831, 97.27, 101.492, 105.713, 109.152],
    },
    45: {
        girl: [93.475, 97.038, 101.412, 105.785, 109.348],
        boy: [94.345, 97.817, 102.078, 106.34, 109.811],
    },
    46: {
        girl: [94.013, 97.611, 102.026, 106.442, 110.04],
        boy: [94.853, 98.357, 102.659, 106.961, 110.465],
    },
    47: {
        girl: [94.546, 98.177, 102.634, 107.091, 110.722],
        boy: [95.358, 98.894, 103.235, 107.576, 111.112],
    },
    48: {
        girl: [95.072, 98.736, 103.234, 107.732, 111.397],
        boy: [95.859, 99.427, 103.807, 108.187, 111.755],
    },
    49: {
        girl: [95.591, 99.289, 103.828, 108.367, 112.065],
        boy: [96.357, 99.957, 104.376, 108.795, 112.396],
    },
    50: {
        girl: [96.105, 99.836, 104.416, 108.996, 112.727],
        boy: [96.855, 100.486, 104.944, 109.401, 113.032],
    },
    51: {
        girl: [96.615, 100.379, 104.998, 109.618, 113.381],
        boy: [97.349, 101.013, 105.509, 110.006, 113.669],
    },
    52: {
        girl: [97.118, 100.914, 105.574, 110.235, 114.031],
        boy: [97.844, 101.539, 106.074, 110.609, 114.304],
    },
    53: {
        girl: [97.617, 101.445, 106.145, 110.845, 114.674],
        boy: [98.338, 102.064, 106.637, 111.211, 114.937],
    },
    54: {
        girl: [98.11, 101.971, 106.71, 111.449, 115.31],
        boy: [98.828, 102.586, 107.2, 111.813, 115.571],
    },
    55: {
        girl: [98.601, 102.492, 107.27, 112.047, 115.939],
        boy: [99.319, 103.109, 107.761, 112.412, 116.202],
    },
    56: {
        girl: [99.083, 103.007, 107.824, 112.64, 116.564],
        boy: [99.811, 103.631, 108.321, 113.01, 116.831],
    },
    57: {
        girl: [99.561, 103.517, 108.372, 113.228, 117.184],
        boy: [100.3, 104.152, 108.88, 113.608, 117.46],
    },
    58: {
        girl: [100.035, 104.022, 108.916, 113.809, 117.796],
        boy: [100.789, 104.672, 109.438, 114.204, 118.087],
    },
    59: {
        girl: [100.505, 104.522, 109.454, 114.385, 118.402],
        boy: [101.275, 105.19, 109.995, 114.8, 118.715],
    },
    60: {
        girl: [100.924, 104.97, 109.935, 114.901, 118.946],
        boy: [101.714, 105.657, 110.497, 115.337, 119.279],
    },
    61: {
        girl: [100.624, 104.655, 109.602, 114.549, 118.579],
        boy: [101.629, 105.506, 110.265, 115.023, 118.9],
    },
    62: {
        girl: [101.087, 105.145, 110.126, 115.107, 119.165],
        boy: [102.106, 106.01, 110.801, 115.592, 119.495],
    },
    63: {
        girl: [101.545, 105.63, 110.645, 115.66, 119.745],
        boy: [102.581, 106.51, 111.334, 116.157, 120.087],
    },
    64: {
        girl: [101.998, 106.111, 111.16, 116.208, 120.321],
        boy: [103.054, 107.009, 111.864, 116.718, 120.673],
    },
    65: {
        girl: [102.449, 106.589, 111.67, 116.751, 120.89],
        boy: [103.522, 107.503, 112.39, 117.276, 121.257],
    },
    66: {
        girl: [102.894, 107.061, 112.175, 117.29, 121.456],
        boy: [103.985, 107.992, 112.911, 117.83, 121.837],
    },
    67: {
        girl: [103.337, 107.53, 112.677, 117.823, 122.016],
        boy: [104.444, 108.478, 113.428, 118.378, 122.412],
    },
    68: {
        girl: [103.776, 107.995, 113.174, 118.353, 122.572],
        boy: [104.902, 108.96, 113.941, 118.922, 122.98],
    },
    69: {
        girl: [104.212, 108.457, 113.667, 118.878, 123.123],
        boy: [105.353, 109.437, 114.45, 119.463, 123.547],
    },
    70: {
        girl: [104.643, 108.914, 114.156, 119.399, 123.67],
        boy: [105.801, 109.91, 114.955, 119.999, 124.109],
    },
    71: {
        girl: [105.071, 109.368, 114.642, 119.916, 124.213],
        boy: [106.246, 110.38, 115.455, 120.53, 124.664],
    },
    72: {
        girl: [105.496, 109.818, 115.124, 120.431, 124.753],
        boy: [106.685, 110.845, 115.951, 121.057, 125.217],
    },
    73: {
        girl: [105.92, 110.267, 115.604, 120.94, 125.288],
        boy: [107.12, 111.306, 116.443, 121.581, 125.766],
    },
    74: {
        girl: [106.342, 110.714, 116.081, 121.448, 125.821],
        boy: [107.555, 111.765, 116.932, 122.1, 126.31],
    },
    75: {
        girl: [106.76, 111.158, 116.557, 121.956, 126.354],
        boy: [107.985, 112.221, 117.42, 122.619, 126.854],
    },
    76: {
        girl: [107.181, 111.603, 117.031, 122.459, 126.881],
        boy: [108.414, 112.674, 117.905, 123.135, 127.396],
    },
    77: {
        girl: [107.599, 112.046, 117.504, 122.963, 127.41],
        boy: [108.842, 113.128, 118.388, 123.648, 127.934],
    },
    78: {
        girl: [108.016, 112.488, 117.977, 123.466, 127.938],
        boy: [109.268, 113.579, 118.87, 124.161, 128.472],
    },
    79: {
        girl: [108.435, 112.931, 118.449, 123.967, 128.463],
        boy: [109.692, 114.028, 119.351, 124.674, 129.01],
    },
    80: {
        girl: [108.851, 113.372, 118.921, 124.47, 128.99],
        boy: [110.114, 114.476, 119.83, 125.184, 129.546],
    },
    81: {
        girl: [109.27, 113.814, 119.393, 124.971, 129.515],
        boy: [110.538, 114.924, 120.308, 125.693, 130.079],
    },
    82: {
        girl: [109.688, 114.257, 119.865, 125.473, 130.041],
        boy: [110.958, 115.37, 120.785, 126.201, 130.613],
    },
    83: {
        girl: [110.107, 114.7, 120.337, 125.975, 130.568],
        boy: [111.376, 115.814, 121.26, 126.707, 131.145],
    },
    84: {
        girl: [110.529, 115.145, 120.81, 126.476, 131.092],
        boy: [111.793, 116.256, 121.734, 127.212, 131.675],
    },
    85: {
        girl: [110.949, 115.589, 121.284, 126.98, 131.62],
        boy: [112.207, 116.696, 122.205, 127.715, 132.203],
    },
    86: {
        girl: [111.371, 116.035, 121.759, 127.483, 132.146],
        boy: [112.62, 117.134, 122.675, 128.216, 132.73],
    },
    87: {
        girl: [111.792, 116.48, 122.234, 127.988, 132.676],
        boy: [113.031, 117.571, 123.143, 128.715, 133.255],
    },
    88: {
        girl: [112.216, 116.927, 122.71, 128.493, 133.204],
        boy: [113.44, 118.006, 123.609, 129.213, 133.778],
    },
    89: {
        girl: [112.643, 117.376, 123.187, 128.997, 133.731],
        boy: [113.848, 118.439, 124.074, 129.709, 134.299],
    },
    90: {
        girl: [113.068, 117.825, 123.665, 129.504, 134.261],
        boy: [114.254, 118.87, 124.536, 130.202, 134.819],
    },
    91: {
        girl: [113.494, 118.275, 124.144, 130.012, 134.793],
        boy: [114.657, 119.299, 124.996, 130.694, 135.336],
    },
    92: {
        girl: [113.923, 118.727, 124.623, 130.52, 135.323],
        boy: [115.058, 119.726, 125.454, 131.183, 135.851],
    },
    93: {
        girl: [114.354, 119.18, 125.104, 131.029, 135.855],
        boy: [115.458, 120.15, 125.91, 131.671, 136.363],
    },
    94: {
        girl: [114.785, 119.635, 125.587, 131.539, 136.388],
        boy: [115.854, 120.573, 126.364, 132.155, 136.874],
    },
    95: {
        girl: [115.218, 120.09, 126.071, 132.051, 136.923],
        boy: [116.249, 120.993, 126.816, 132.638, 137.382],
    },
    96: {
        girl: [115.652, 120.547, 126.556, 132.565, 137.46],
        boy: [116.642, 121.411, 127.265, 133.119, 137.888],
    },
    97: {
        girl: [116.087, 121.005, 127.042, 133.08, 137.998],
        boy: [117.034, 121.828, 127.713, 133.598, 138.392],
    },
    98: {
        girl: [116.526, 121.466, 127.53, 133.595, 138.535],
        boy: [117.423, 122.243, 128.159, 134.075, 138.895],
    },
    99: {
        girl: [116.966, 121.928, 128.02, 134.111, 139.074],
        boy: [117.811, 122.656, 128.603, 134.551, 139.396],
    },
    100: {
        girl: [117.407, 122.392, 128.511, 134.63, 139.615],
        boy: [118.197, 123.068, 129.047, 135.025, 139.896],
    },
    101: {
        girl: [117.85, 122.857, 129.004, 135.15, 140.157],
        boy: [118.583, 123.479, 129.489, 135.498, 140.394],
    },
    102: {
        girl: [118.294, 123.324, 129.498, 135.671, 140.701],
        boy: [118.965, 123.888, 129.93, 135.972, 140.895],
    },
    103: {
        girl: [118.742, 123.793, 129.993, 136.193, 141.245],
        boy: [119.349, 124.297, 130.37, 136.444, 141.392],
    },
    104: {
        girl: [119.191, 124.264, 130.49, 136.717, 141.79],
        boy: [119.732, 124.705, 130.81, 136.915, 141.889],
    },
    105: {
        girl: [119.639, 124.735, 130.989, 137.244, 142.339],
        boy: [120.114, 125.113, 131.25, 137.386, 142.385],
    },
    106: {
        girl: [120.094, 125.21, 131.49, 137.769, 142.885],
        boy: [120.496, 125.521, 131.688, 137.856, 142.881],
    },
    107: {
        girl: [120.547, 125.685, 131.991, 138.298, 143.435],
        boy: [120.877, 125.928, 132.127, 138.326, 143.377],
    },
    108: {
        girl: [121.002, 126.161, 132.494, 138.828, 143.987],
        boy: [121.258, 126.334, 132.565, 138.796, 143.872],
    },
    109: {
        girl: [121.46, 126.64, 132.999, 139.358, 144.538],
        boy: [121.639, 126.741, 133.003, 139.266, 144.367],
    },
    110: {
        girl: [121.919, 127.12, 133.505, 139.889, 145.09],
        boy: [122.019, 127.146, 133.44, 139.735, 144.862],
    },
    111: {
        girl: [122.38, 127.602, 134.012, 140.422, 145.644],
        boy: [122.398, 127.551, 133.877, 140.203, 145.356],
    },
    112: {
        girl: [122.842, 128.085, 134.52, 140.956, 146.199],
        boy: [122.779, 127.957, 134.313, 140.669, 145.847],
    },
    113: {
        girl: [123.307, 128.57, 135.03, 141.49, 146.753],
        boy: [123.156, 128.36, 134.748, 141.136, 146.34],
    },
    114: {
        girl: [123.771, 129.055, 135.541, 142.027, 147.311],
        boy: [123.533, 128.763, 135.183, 141.603, 146.833],
    },
    115: {
        girl: [124.239, 129.543, 136.053, 142.564, 147.868],
        boy: [123.912, 129.167, 135.617, 142.067, 147.322],
    },
    116: {
        girl: [124.711, 130.033, 136.567, 143.101, 148.423],
        boy: [124.287, 129.568, 136.05, 142.532, 147.813],
    },
    117: {
        girl: [125.181, 130.524, 137.082, 143.64, 148.983],
        boy: [124.665, 129.97, 136.483, 142.996, 148.301],
    },
    118: {
        girl: [125.653, 131.016, 137.599, 144.182, 149.545],
        boy: [125.039, 130.371, 136.915, 143.46, 148.792],
    },
    119: {
        girl: [126.128, 131.51, 138.117, 144.723, 150.105],
        boy: [125.416, 130.772, 137.347, 143.923, 149.279],
    },
    120: {
        girl: [126.605, 132.007, 138.636, 145.266, 150.667],
        boy: [125.792, 131.174, 137.78, 144.385, 149.767],
    },
    121: {
        girl: [127.087, 132.506, 139.158, 145.809, 151.228],
        boy: [126.169, 131.575, 138.212, 144.849, 150.255],
    },
    122: {
        girl: [127.567, 133.005, 139.68, 146.356, 151.794],
        boy: [126.546, 131.978, 138.645, 145.313, 150.745],
    },
    123: {
        girl: [128.051, 133.507, 140.205, 146.902, 152.359],
        boy: [126.924, 132.381, 139.08, 145.778, 151.235],
    },
    124: {
        girl: [128.537, 134.012, 140.731, 147.451, 152.925],
        boy: [127.304, 132.786, 139.516, 146.245, 151.728],
    },
    125: {
        girl: [129.025, 134.517, 141.259, 148.001, 153.494],
        boy: [127.685, 133.193, 139.954, 146.715, 152.223],
    },
    126: {
        girl: [129.514, 135.025, 141.789, 148.554, 154.064],
        boy: [128.071, 133.604, 140.395, 147.186, 152.718],
    },
    127: {
        girl: [130.008, 135.535, 142.321, 149.106, 154.634],
        boy: [128.458, 134.016, 140.839, 147.661, 153.22],
    },
    128: {
        girl: [130.502, 136.047, 142.853, 149.66, 155.205],
        boy: [128.85, 134.433, 141.286, 148.139, 153.722],
    },
    129: {
        girl: [130.998, 136.56, 143.387, 150.215, 155.777],
        boy: [129.245, 134.853, 141.737, 148.621, 154.229],
    },
    130: {
        girl: [131.495, 137.074, 143.922, 150.77, 156.349],
        boy: [129.644, 135.277, 142.192, 149.106, 154.74],
    },
    131: {
        girl: [131.992, 137.588, 144.458, 151.327, 156.923],
        boy: [130.046, 135.704, 142.65, 149.596, 155.255],
    },
    132: {
        girl: [132.492, 138.104, 144.993, 151.882, 157.494],
        boy: [130.454, 136.137, 143.113, 150.088, 155.771],
    },
    133: {
        girl: [132.992, 138.62, 145.528, 152.436, 158.064],
        boy: [130.863, 136.572, 143.58, 150.587, 156.296],
    },
    134: {
        girl: [133.491, 139.135, 146.062, 152.99, 158.633],
        boy: [131.279, 137.013, 144.051, 151.089, 156.823],
    },
    135: {
        girl: [133.992, 139.65, 146.595, 153.54, 159.198],
        boy: [131.7, 137.459, 144.528, 151.596, 157.355],
    },
    136: {
        girl: [134.489, 140.162, 147.126, 154.09, 159.764],
        boy: [132.128, 137.911, 145.009, 152.108, 157.89],
    },
    137: {
        girl: [134.986, 140.673, 147.655, 154.636, 160.324],
        boy: [132.558, 138.367, 145.496, 152.626, 158.435],
    },
    138: {
        girl: [135.48, 141.182, 148.18, 155.179, 160.881],
        boy: [132.996, 138.829, 145.989, 153.149, 158.982],
    },
    139: {
        girl: [135.971, 141.687, 148.702, 155.718, 161.433],
        boy: [133.439, 139.297, 146.488, 153.678, 159.536],
    },
    140: {
        girl: [136.461, 142.189, 149.22, 156.25, 161.978],
        boy: [133.888, 139.771, 146.993, 154.214, 160.097],
    },
    141: {
        girl: [136.944, 142.685, 149.732, 156.779, 162.52],
        boy: [134.343, 140.252, 147.504, 154.757, 160.665],
    },
    142: {
        girl: [137.425, 143.177, 150.239, 157.301, 163.053],
        boy: [134.807, 140.74, 148.022, 155.305, 161.238],
    },
    143: {
        girl: [137.899, 143.664, 150.739, 157.815, 163.58],
        boy: [135.277, 141.235, 148.548, 155.861, 161.819],
    },
    144: {
        girl: [138.368, 144.143, 151.233, 158.322, 164.098],
        boy: [135.754, 141.737, 149.081, 156.425, 162.408],
    },
    145: {
        girl: [138.832, 144.617, 151.718, 158.819, 164.605],
        boy: [136.24, 142.248, 149.621, 156.995, 163.002],
    },
    146: {
        girl: [139.285, 145.081, 152.195, 159.309, 165.105],
        boy: [136.731, 142.764, 150.169, 157.575, 163.608],
    },
    147: {
        girl: [139.733, 145.538, 152.663, 159.788, 165.592],
        boy: [137.235, 143.291, 150.726, 158.16, 164.217],
    },
    148: {
        girl: [140.17, 145.984, 153.121, 160.257, 166.071],
        boy: [137.743, 143.825, 151.29, 158.755, 164.837],
    },
    149: {
        girl: [140.599, 146.421, 153.568, 160.714, 166.536],
        boy: [138.261, 144.367, 151.862, 159.357, 165.464],
    },
    150: {
        girl: [141.019, 146.849, 154.004, 161.16, 166.989],
        boy: [138.786, 144.917, 152.442, 159.968, 166.099],
    },
    151: {
        girl: [141.428, 147.265, 154.429, 161.593, 167.43],
        boy: [139.321, 145.475, 153.03, 160.584, 166.739],
    },
    152: {
        girl: [141.83, 147.672, 154.842, 162.013, 167.854],
        boy: [139.859, 146.038, 153.623, 161.209, 167.388],
    },
    153: {
        girl: [142.218, 148.066, 155.244, 162.421, 168.269],
        boy: [140.407, 146.609, 154.222, 161.836, 168.038],
    },
    154: {
        girl: [142.596, 148.449, 155.633, 162.817, 168.67],
        boy: [140.956, 147.183, 154.826, 162.469, 168.695],
    },
    155: {
        girl: [142.965, 148.821, 156.01, 163.199, 169.056],
        boy: [141.512, 147.762, 155.433, 163.104, 169.354],
    },
    156: {
        girl: [143.319, 149.18, 156.375, 163.569, 169.43],
        boy: [142.073, 148.344, 156.043, 163.741, 170.012],
    },
    157: {
        girl: [143.666, 149.529, 156.727, 163.924, 169.788],
        boy: [142.635, 148.929, 156.654, 164.379, 170.673],
    },
    158: {
        girl: [144.001, 149.866, 157.067, 164.267, 170.133],
        boy: [143.198, 149.514, 157.266, 165.018, 171.334],
    },
    159: {
        girl: [144.324, 150.191, 157.394, 164.596, 170.463],
        boy: [143.761, 150.099, 157.878, 165.656, 171.994],
    },
    160: {
        girl: [144.633, 150.503, 157.708, 164.913, 170.783],
        boy: [144.325, 150.683, 158.487, 166.291, 172.649],
    },
    161: {
        girl: [144.934, 150.804, 158.01, 165.216, 171.086],
        boy: [144.89, 151.266, 159.094, 166.921, 173.298],
    },
    162: {
        girl: [145.223, 151.094, 158.3, 165.506, 171.376],
        boy: [145.447, 151.844, 159.696, 167.548, 173.945],
    },
    163: {
        girl: [145.502, 151.372, 158.577, 165.782, 171.652],
        boy: [146.004, 152.419, 160.294, 168.169, 174.584],
    },
    164: {
        girl: [145.769, 151.638, 158.842, 166.047, 171.916],
        boy: [146.558, 152.991, 160.886, 168.782, 175.214],
    },
    165: {
        girl: [146.023, 151.892, 159.096, 166.3, 172.169],
        boy: [147.107, 153.556, 161.472, 169.388, 175.837],
    },
    166: {
        girl: [146.269, 152.136, 159.338, 166.54, 172.407],
        boy: [147.649, 154.115, 162.05, 169.986, 176.452],
    },
    167: {
        girl: [146.505, 152.37, 159.569, 166.768, 172.633],
        boy: [148.184, 154.665, 162.621, 170.576, 177.057],
    },
    168: {
        girl: [146.731, 152.593, 159.789, 166.985, 172.847],
        boy: [148.714, 155.209, 163.182, 171.154, 177.649],
    },
    169: {
        girl: [146.947, 152.806, 159.998, 167.19, 173.049],
        boy: [149.237, 155.744, 163.732, 171.72, 178.227],
    },
    170: {
        girl: [147.151, 153.008, 160.197, 167.386, 173.243],
        boy: [149.747, 156.268, 164.272, 172.275, 178.796],
    },
    171: {
        girl: [147.348, 153.201, 160.386, 167.57, 173.423],
        boy: [150.25, 156.782, 164.799, 172.817, 179.349],
    },
    172: {
        girl: [147.537, 153.385, 160.564, 167.743, 173.592],
        boy: [150.742, 157.284, 165.314, 173.345, 179.887],
    },
    173: {
        girl: [147.713, 153.558, 160.733, 167.908, 173.754],
        boy: [151.224, 157.775, 165.816, 173.858, 180.409],
    },
    174: {
        girl: [147.884, 153.724, 160.893, 168.061, 173.902],
        boy: [151.695, 158.254, 166.305, 174.356, 180.915],
    },
    175: {
        girl: [148.043, 153.879, 161.043, 168.207, 174.043],
        boy: [152.153, 158.72, 166.78, 174.84, 181.407],
    },
    176: {
        girl: [148.197, 154.028, 161.184, 168.341, 174.172],
        boy: [152.599, 159.173, 167.242, 175.31, 181.884],
    },
    177: {
        girl: [148.341, 154.167, 161.318, 168.469, 174.294],
        boy: [153.037, 159.615, 167.69, 175.765, 182.343],
    },
    178: {
        girl: [148.477, 154.298, 161.442, 168.587, 174.408],
        boy: [153.463, 160.045, 168.126, 176.206, 182.788],
    },
    179: {
        girl: [148.606, 154.421, 161.56, 168.698, 174.513],
        boy: [153.877, 160.464, 168.548, 176.633, 183.219],
    },
    180: {
        girl: [148.731, 154.54, 161.669, 168.799, 174.607],
        boy: [154.28, 160.869, 168.958, 177.047, 183.636],
    },
    181: {
        girl: [148.847, 154.649, 161.772, 168.894, 174.697],
        boy: [154.674, 161.265, 169.355, 177.445, 184.036],
    },
    182: {
        girl: [148.956, 154.752, 161.867, 168.982, 174.779],
        boy: [155.057, 161.648, 169.739, 177.83, 184.421],
    },
    183: {
        girl: [149.056, 154.848, 161.956, 169.065, 174.856],
        boy: [155.428, 162.019, 170.11, 178.201, 184.792],
    },
    184: {
        girl: [149.154, 154.939, 162.039, 169.14, 174.925],
        boy: [155.787, 162.378, 170.468, 178.558, 185.149],
    },
    185: {
        girl: [149.246, 155.024, 162.116, 169.209, 174.987],
        boy: [156.135, 162.725, 170.814, 178.902, 185.492],
    },
    186: {
        girl: [149.334, 155.104, 162.188, 169.272, 175.042],
        boy: [156.472, 163.06, 171.147, 179.234, 185.822],
    },
    187: {
        girl: [149.413, 155.178, 162.254, 169.331, 175.096],
        boy: [156.801, 163.386, 171.468, 179.55, 186.135],
    },
    188: {
        girl: [149.491, 155.248, 162.315, 169.383, 175.14],
        boy: [157.116, 163.698, 171.777, 179.857, 186.439],
    },
    189: {
        girl: [149.561, 155.312, 162.372, 169.432, 175.183],
        boy: [157.424, 164.001, 172.075, 180.148, 186.726],
    },
    190: {
        girl: [149.627, 155.372, 162.424, 169.476, 175.221],
        boy: [157.721, 164.293, 172.361, 180.428, 187],
    },
    191: {
        girl: [149.693, 155.43, 162.472, 169.514, 175.251],
        boy: [158.004, 164.572, 172.634, 180.697, 187.265],
    },
    192: {
        girl: [149.751, 155.482, 162.516, 169.55, 175.28],
        boy: [158.28, 164.842, 172.897, 180.952, 187.514],
    },
    193: {
        girl: [149.807, 155.53, 162.556, 169.582, 175.305],
        boy: [158.545, 165.1, 173.147, 181.194, 187.749],
    },
    194: {
        girl: [149.86, 155.576, 162.593, 169.61, 175.327],
        boy: [158.799, 165.348, 173.386, 181.424, 187.972],
    },
    195: {
        girl: [149.91, 155.619, 162.628, 169.636, 175.346],
        boy: [159.043, 165.584, 173.613, 181.641, 188.182],
    },
    196: {
        girl: [149.957, 155.66, 162.659, 169.659, 175.362],
        boy: [159.276, 165.809, 173.828, 181.847, 188.38],
    },
    197: {
        girl: [150, 155.696, 162.689, 169.682, 175.378],
        boy: [159.499, 166.024, 174.032, 182.041, 188.565],
    },
    198: {
        girl: [150.044, 155.733, 162.716, 169.7, 175.389],
        boy: [159.712, 166.228, 174.225, 182.223, 188.738],
    },
    199: {
        girl: [150.083, 155.766, 162.742, 169.719, 175.402],
        boy: [159.915, 166.421, 174.407, 182.393, 188.899],
    },
    200: {
        girl: [150.124, 155.8, 162.767, 169.734, 175.41],
        boy: [160.108, 166.604, 174.578, 182.552, 189.049],
    },
    201: {
        girl: [150.161, 155.831, 162.79, 169.75, 175.42],
        boy: [160.292, 166.778, 174.739, 182.701, 189.187],
    },
    202: {
        girl: [150.2, 155.862, 162.813, 169.763, 175.426],
        boy: [160.466, 166.941, 174.89, 182.838, 189.313],
    },
    203: {
        girl: [150.235, 155.891, 162.834, 169.777, 175.433],
        boy: [160.628, 167.094, 175.03, 182.967, 189.432],
    },
    204: {
        girl: [150.269, 155.919, 162.854, 169.79, 175.44],
        boy: [160.784, 167.238, 175.161, 183.083, 189.538],
    },
    205: {
        girl: [150.302, 155.946, 162.874, 169.802, 175.446],
        boy: [160.932, 167.374, 175.282, 183.19, 189.633],
    },
    206: {
        girl: [150.335, 155.973, 162.894, 169.814, 175.452],
        boy: [161.068, 167.5, 175.395, 183.29, 189.722],
    },
    207: {
        girl: [150.368, 155.999, 162.912, 169.825, 175.456],
        boy: [161.201, 167.62, 175.5, 183.379, 189.798],
    },
    208: {
        girl: [150.4, 156.025, 162.93, 169.835, 175.46],
        boy: [161.322, 167.73, 175.596, 183.462, 189.87],
    },
    209: {
        girl: [150.431, 156.05, 162.948, 169.845, 175.464],
        boy: [161.44, 167.835, 175.685, 183.535, 189.93],
    },
    210: {
        girl: [150.46, 156.074, 162.965, 169.856, 175.47],
        boy: [161.549, 167.932, 175.767, 183.602, 189.986],
    },
    211: {
        girl: [150.49, 156.098, 162.982, 169.865, 175.473],
        boy: [161.652, 168.023, 175.843, 183.664, 190.035],
    },
    212: {
        girl: [150.518, 156.121, 162.998, 169.876, 175.479],
        boy: [161.749, 168.108, 175.913, 183.719, 190.077],
    },
    213: {
        girl: [150.548, 156.145, 163.014, 169.884, 175.481],
        boy: [161.842, 168.188, 175.978, 183.768, 190.114],
    },
    214: {
        girl: [150.575, 156.166, 163.03, 169.894, 175.485],
        boy: [161.93, 168.264, 176.038, 183.812, 190.146],
    },
    215: {
        girl: [150.601, 156.188, 163.045, 169.903, 175.489],
        boy: [162.014, 168.335, 176.094, 183.852, 190.173],
    },
    216: {
        girl: [150.63, 156.21, 163.06, 169.909, 175.489],
        boy: [162.095, 168.402, 176.145, 183.887, 190.195],
    },
    217: {
        girl: [150.655, 156.23, 163.073, 169.917, 175.492],
        boy: [162.168, 168.464, 176.192, 183.921, 190.217],
    },
    218: {
        girl: [150.679, 156.249, 163.086, 169.923, 175.493],
        boy: [162.242, 168.525, 176.237, 183.949, 190.231],
    },
    219: {
        girl: [150.702, 156.267, 163.098, 169.929, 175.494],
        boy: [162.31, 168.581, 176.278, 183.975, 190.246],
    },
    220: {
        girl: [150.725, 156.285, 163.109, 169.934, 175.494],
        boy: [162.375, 168.634, 176.316, 183.999, 190.257],
    },
    221: {
        girl: [150.743, 156.299, 163.119, 169.939, 175.495],
        boy: [162.438, 168.684, 176.352, 184.019, 190.266],
    },
    222: {
        girl: [150.763, 156.314, 163.128, 169.941, 175.492],
        boy: [162.502, 168.734, 176.385, 184.036, 190.269],
    },
    223: {
        girl: [150.783, 156.328, 163.136, 169.943, 175.488],
        boy: [162.557, 168.779, 176.416, 184.054, 190.276],
    },
    224: {
        girl: [150.798, 156.339, 163.142, 169.944, 175.486],
        boy: [162.613, 168.823, 176.445, 184.067, 190.277],
    },
    225: {
        girl: [150.815, 156.351, 163.147, 169.943, 175.479],
        boy: [162.668, 168.866, 176.472, 184.079, 190.276],
    },
    226: {
        girl: [150.828, 156.36, 163.151, 169.942, 175.474],
        boy: [162.721, 168.906, 176.498, 184.089, 190.274],
    },
    227: {
        girl: [150.842, 156.369, 163.153, 169.938, 175.465],
        boy: [162.77, 168.943, 176.521, 184.099, 190.273],
    },
    228: {
        girl: [150.853, 156.376, 163.155, 169.934, 175.457],
        boy: [162.817, 168.979, 176.543, 184.107, 190.27],
    },
}
export const bmi = {
    0: {
        girl: [11.213, 12.118, 13.336, 14.686, 15.892],
        boy: [11.254, 12.16, 13.407, 14.826, 16.13],
    },
    1: {
        girl: [12.078, 13.148, 14.542, 16.03, 17.313],
        boy: [12.532, 13.564, 14.914, 16.359, 17.609],
    },
    2: {
        girl: [13.186, 14.3, 15.771, 17.366, 18.761],
        boy: [13.845, 14.913, 16.323, 17.851, 19.188],
    },
    3: {
        girl: [13.74, 14.866, 16.367, 18.009, 19.459],
        boy: [14.41, 15.482, 16.907, 18.462, 19.834],
    },
    4: {
        girl: [14.044, 15.17, 16.68, 18.343, 19.823],
        boy: [14.677, 15.743, 17.165, 18.727, 20.113],
    },
    5: {
        girl: [14.216, 15.336, 16.845, 18.517, 20.013],
        boy: [14.824, 15.881, 17.297, 18.859, 20.251],
    },
    6: {
        girl: [14.298, 15.409, 16.91, 18.582, 20.084],
        boy: [14.89, 15.936, 17.343, 18.901, 20.295],
    },
    7: {
        girl: [14.311, 15.409, 16.898, 18.562, 20.065],
        boy: [14.896, 15.93, 17.325, 18.874, 20.265],
    },
    8: {
        girl: [14.274, 15.358, 16.831, 18.483, 19.979],
        boy: [14.855, 15.875, 17.255, 18.792, 20.177],
    },
    9: {
        girl: [14.203, 15.27, 16.725, 18.362, 19.85],
        boy: [14.782, 15.788, 17.151, 18.674, 20.05],
    },
    10: {
        girl: [14.111, 15.163, 16.599, 18.219, 19.695],
        boy: [14.692, 15.684, 17.03, 18.538, 19.903],
    },
    11: {
        girl: [14.011, 15.047, 16.465, 18.068, 19.532],
        boy: [14.595, 15.573, 16.902, 18.395, 19.749],
    },
    12: {
        girl: [13.911, 14.933, 16.333, 17.919, 19.372],
        boy: [14.496, 15.461, 16.775, 18.252, 19.596],
    },
    13: {
        girl: [13.815, 14.823, 16.206, 17.776, 19.218],
        boy: [14.398, 15.351, 16.649, 18.112, 19.445],
    },
    14: {
        girl: [13.724, 14.719, 16.087, 17.643, 19.074],
        boy: [14.304, 15.245, 16.529, 17.978, 19.301],
    },
    15: {
        girl: [13.641, 14.624, 15.977, 17.52, 18.94],
        boy: [14.214, 15.144, 16.414, 17.85, 19.164],
    },
    16: {
        girl: [13.564, 14.536, 15.877, 17.406, 18.818],
        boy: [14.129, 15.049, 16.306, 17.73, 19.035],
    },
    17: {
        girl: [13.494, 14.457, 15.785, 17.304, 18.707],
        boy: [14.05, 14.96, 16.206, 17.619, 18.914],
    },
    18: {
        girl: [13.432, 14.386, 15.703, 17.211, 18.607],
        boy: [13.977, 14.877, 16.113, 17.515, 18.802],
    },
    19: {
        girl: [13.377, 14.322, 15.63, 17.128, 18.517],
        boy: [13.909, 14.802, 16.027, 17.419, 18.699],
    },
    20: {
        girl: [13.329, 14.267, 15.565, 17.055, 18.438],
        boy: [13.849, 14.734, 15.95, 17.333, 18.606],
    },
    21: {
        girl: [13.288, 14.219, 15.509, 16.992, 18.37],
        boy: [13.796, 14.674, 15.881, 17.256, 18.523],
    },
    22: {
        girl: [13.254, 14.179, 15.463, 16.939, 18.312],
        boy: [13.749, 14.62, 15.82, 17.187, 18.449],
    },
    23: {
        girl: [13.227, 14.147, 15.424, 16.895, 18.265],
        boy: [13.707, 14.573, 15.765, 17.126, 18.383],
    },
    24: {
        girl: [13.463, 14.392, 15.676, 17.15, 18.519],
        boy: [13.908, 14.791, 16.003, 17.384, 18.656],
    },
    25: {
        girl: [13.438, 14.365, 15.647, 17.118, 18.483],
        boy: [13.867, 14.751, 15.963, 17.34, 18.604],
    },
    26: {
        girl: [13.415, 14.339, 15.619, 17.086, 18.449],
        boy: [13.826, 14.712, 15.924, 17.297, 18.554],
    },
    27: {
        girl: [13.392, 14.315, 15.592, 17.056, 18.415],
        boy: [13.786, 14.674, 15.886, 17.255, 18.506],
    },
    28: {
        girl: [13.37, 14.291, 15.565, 17.027, 18.384],
        boy: [13.747, 14.637, 15.849, 17.215, 18.46],
    },
    29: {
        girl: [13.348, 14.268, 15.54, 16.999, 18.354],
        boy: [13.709, 14.6, 15.813, 17.176, 18.415],
    },
    30: {
        girl: [13.326, 14.245, 15.515, 16.972, 18.325],
        boy: [13.671, 14.564, 15.777, 17.138, 18.373],
    },
    31: {
        girl: [13.304, 14.222, 15.491, 16.947, 18.299],
        boy: [13.634, 14.529, 15.742, 17.101, 18.331],
    },
    32: {
        girl: [13.281, 14.198, 15.467, 16.923, 18.274],
        boy: [13.598, 14.494, 15.708, 17.065, 18.292],
    },
    33: {
        girl: [13.259, 14.176, 15.445, 16.901, 18.254],
        boy: [13.563, 14.46, 15.675, 17.031, 18.254],
    },
    34: {
        girl: [13.236, 14.153, 15.423, 16.882, 18.237],
        boy: [13.528, 14.427, 15.642, 16.997, 18.219],
    },
    35: {
        girl: [13.213, 14.132, 15.404, 16.865, 18.223],
        boy: [13.495, 14.395, 15.611, 16.965, 18.185],
    },
    36: {
        girl: [13.19, 14.111, 15.386, 16.851, 18.214],
        boy: [13.462, 14.363, 15.58, 16.935, 18.154],
    },
    37: {
        girl: [13.167, 14.09, 15.369, 16.84, 18.209],
        boy: [13.431, 14.333, 15.551, 16.906, 18.124],
    },
    38: {
        girl: [13.144, 14.07, 15.354, 16.832, 18.207],
        boy: [13.401, 14.304, 15.523, 16.879, 18.098],
    },
    39: {
        girl: [13.121, 14.05, 15.34, 16.825, 18.21],
        boy: [13.373, 14.276, 15.496, 16.854, 18.075],
    },
    40: {
        girl: [13.098, 14.031, 15.327, 16.821, 18.214],
        boy: [13.345, 14.25, 15.471, 16.831, 18.054],
    },
    41: {
        girl: [13.075, 14.012, 15.315, 16.818, 18.221],
        boy: [13.32, 14.225, 15.448, 16.81, 18.037],
    },
    42: {
        girl: [13.052, 13.993, 15.303, 16.816, 18.23],
        boy: [13.296, 14.202, 15.426, 16.792, 18.022],
    },
    43: {
        girl: [13.029, 13.976, 15.293, 16.816, 18.24],
        boy: [13.272, 14.179, 15.406, 16.775, 18.009],
    },
    44: {
        girl: [13.007, 13.958, 15.283, 16.817, 18.252],
        boy: [13.251, 14.158, 15.387, 16.76, 18],
    },
    45: {
        girl: [12.987, 13.942, 15.275, 16.818, 18.265],
        boy: [13.229, 14.137, 15.369, 16.746, 17.992],
    },
    46: {
        girl: [12.967, 13.927, 15.267, 16.821, 18.279],
        boy: [13.209, 14.118, 15.352, 16.734, 17.987],
    },
    47: {
        girl: [12.948, 13.913, 15.261, 16.825, 18.294],
        boy: [13.19, 14.099, 15.335, 16.724, 17.984],
    },
    48: {
        girl: [12.931, 13.901, 15.256, 16.831, 18.311],
        boy: [13.171, 14.081, 15.32, 16.714, 17.982],
    },
    49: {
        girl: [12.915, 13.889, 15.253, 16.838, 18.33],
        boy: [13.153, 14.063, 15.305, 16.705, 17.983],
    },
    50: {
        girl: [12.9, 13.879, 15.251, 16.847, 18.351],
        boy: [13.136, 14.046, 15.291, 16.698, 17.984],
    },
    51: {
        girl: [12.886, 13.87, 15.25, 16.857, 18.372],
        boy: [13.119, 14.03, 15.277, 16.691, 17.988],
    },
    52: {
        girl: [12.873, 13.863, 15.25, 16.868, 18.395],
        boy: [13.104, 14.014, 15.264, 16.686, 17.994],
    },
    53: {
        girl: [12.862, 13.857, 15.252, 16.88, 18.419],
        boy: [13.088, 13.998, 15.252, 16.682, 18.001],
    },
    54: {
        girl: [12.853, 13.852, 15.254, 16.893, 18.442],
        boy: [13.073, 13.984, 15.24, 16.678, 18.009],
    },
    55: {
        girl: [12.844, 13.848, 15.258, 16.906, 18.466],
        boy: [13.059, 13.97, 15.229, 16.676, 18.019],
    },
    56: {
        girl: [12.837, 13.845, 15.261, 16.919, 18.489],
        boy: [13.046, 13.956, 15.219, 16.674, 18.03],
    },
    57: {
        girl: [12.831, 13.842, 15.265, 16.932, 18.512],
        boy: [13.033, 13.943, 15.209, 16.673, 18.043],
    },
    58: {
        girl: [12.825, 13.841, 15.27, 16.945, 18.534],
        boy: [13.021, 13.93, 15.2, 16.673, 18.057],
    },
    59: {
        girl: [12.821, 13.84, 15.275, 16.958, 18.555],
        boy: [13.009, 13.919, 15.191, 16.674, 18.073],
    },
    60: {
        girl: [12.818, 13.84, 15.28, 16.97, 18.574],
        boy: [13, 13.909, 15.184, 16.675, 18.088],
    },
    61: {
        girl: [12.874, 13.846, 15.244, 16.936, 18.598],
        boy: [13.148, 14.03, 15.264, 16.7, 18.052],
    },
    62: {
        girl: [12.868, 13.84, 15.243, 16.945, 18.624],
        boy: [13.144, 14.026, 15.262, 16.703, 18.065],
    },
    63: {
        girl: [12.861, 13.835, 15.243, 16.956, 18.65],
        boy: [13.14, 14.023, 15.26, 16.708, 18.08],
    },
    64: {
        girl: [12.855, 13.831, 15.244, 16.967, 18.677],
        boy: [13.138, 14.02, 15.26, 16.714, 18.096],
    },
    65: {
        girl: [12.85, 13.827, 15.245, 16.979, 18.705],
        boy: [13.137, 14.019, 15.262, 16.722, 18.114],
    },
    66: {
        girl: [12.845, 13.824, 15.246, 16.991, 18.734],
        boy: [13.137, 14.019, 15.264, 16.732, 18.134],
    },
    67: {
        girl: [12.841, 13.821, 15.249, 17.005, 18.764],
        boy: [13.138, 14.02, 15.268, 16.743, 18.156],
    },
    68: {
        girl: [12.837, 13.819, 15.252, 17.019, 18.795],
        boy: [13.14, 14.023, 15.274, 16.755, 18.18],
    },
    69: {
        girl: [12.834, 13.817, 15.255, 17.034, 18.827],
        boy: [13.143, 14.026, 15.28, 16.769, 18.205],
    },
    70: {
        girl: [12.831, 13.816, 15.259, 17.049, 18.86],
        boy: [13.146, 14.031, 15.288, 16.784, 18.232],
    },
    71: {
        girl: [12.829, 13.816, 15.264, 17.065, 18.894],
        boy: [13.151, 14.036, 15.296, 16.801, 18.261],
    },
    72: {
        girl: [12.828, 13.816, 15.27, 17.083, 18.929],
        boy: [13.157, 14.042, 15.306, 16.819, 18.291],
    },
    73: {
        girl: [12.827, 13.817, 15.276, 17.101, 18.966],
        boy: [13.163, 14.049, 15.317, 16.838, 18.323],
    },
    74: {
        girl: [12.826, 13.818, 15.283, 17.12, 19.003],
        boy: [13.17, 14.057, 15.328, 16.858, 18.356],
    },
    75: {
        girl: [12.827, 13.821, 15.291, 17.14, 19.042],
        boy: [13.177, 14.065, 15.341, 16.879, 18.39],
    },
    76: {
        girl: [12.828, 13.824, 15.3, 17.161, 19.081],
        boy: [13.185, 14.075, 15.354, 16.902, 18.426],
    },
    77: {
        girl: [12.83, 13.828, 15.31, 17.183, 19.123],
        boy: [13.193, 14.084, 15.368, 16.925, 18.463],
    },
    78: {
        girl: [12.832, 13.832, 15.32, 17.206, 19.165],
        boy: [13.202, 14.095, 15.382, 16.949, 18.501],
    },
    79: {
        girl: [12.836, 13.838, 15.331, 17.23, 19.209],
        boy: [13.212, 14.105, 15.398, 16.974, 18.541],
    },
    80: {
        girl: [12.84, 13.844, 15.344, 17.255, 19.254],
        boy: [13.222, 14.117, 15.414, 17, 18.582],
    },
    81: {
        girl: [12.845, 13.851, 15.357, 17.281, 19.3],
        boy: [13.232, 14.128, 15.43, 17.026, 18.623],
    },
    82: {
        girl: [12.851, 13.86, 15.372, 17.309, 19.348],
        boy: [13.242, 14.141, 15.447, 17.054, 18.666],
    },
    83: {
        girl: [12.857, 13.869, 15.387, 17.337, 19.397],
        boy: [13.253, 14.153, 15.465, 17.082, 18.71],
    },
    84: {
        girl: [12.865, 13.879, 15.404, 17.367, 19.448],
        boy: [13.265, 14.166, 15.483, 17.111, 18.756],
    },
    85: {
        girl: [12.873, 13.89, 15.421, 17.398, 19.501],
        boy: [13.276, 14.18, 15.502, 17.14, 18.801],
    },
    86: {
        girl: [12.882, 13.902, 15.44, 17.43, 19.554],
        boy: [13.288, 14.194, 15.521, 17.17, 18.848],
    },
    87: {
        girl: [12.892, 13.914, 15.459, 17.464, 19.609],
        boy: [13.301, 14.208, 15.541, 17.202, 18.897],
    },
    88: {
        girl: [12.903, 13.928, 15.48, 17.499, 19.666],
        boy: [13.313, 14.223, 15.561, 17.233, 18.945],
    },
    89: {
        girl: [12.915, 13.943, 15.501, 17.534, 19.723],
        boy: [13.326, 14.238, 15.581, 17.265, 18.996],
    },
    90: {
        girl: [12.927, 13.958, 15.524, 17.571, 19.783],
        boy: [13.339, 14.253, 15.602, 17.298, 19.047],
    },
    91: {
        girl: [12.94, 13.974, 15.548, 17.609, 19.843],
        boy: [13.352, 14.268, 15.624, 17.332, 19.098],
    },
    92: {
        girl: [12.954, 13.992, 15.572, 17.648, 19.905],
        boy: [13.365, 14.284, 15.646, 17.366, 19.151],
    },
    93: {
        girl: [12.969, 14.01, 15.598, 17.689, 19.969],
        boy: [13.379, 14.3, 15.668, 17.4, 19.205],
    },
    94: {
        girl: [12.984, 14.029, 15.625, 17.73, 20.034],
        boy: [13.393, 14.317, 15.69, 17.435, 19.259],
    },
    95: {
        girl: [13.001, 14.049, 15.652, 17.773, 20.1],
        boy: [13.407, 14.333, 15.713, 17.471, 19.315],
    },
    96: {
        girl: [13.018, 14.07, 15.681, 17.817, 20.167],
        boy: [13.422, 14.35, 15.737, 17.508, 19.371],
    },
    97: {
        girl: [13.036, 14.091, 15.711, 17.862, 20.235],
        boy: [13.436, 14.368, 15.761, 17.544, 19.428],
    },
    98: {
        girl: [13.055, 14.114, 15.742, 17.908, 20.305],
        boy: [13.451, 14.385, 15.785, 17.582, 19.486],
    },
    99: {
        girl: [13.075, 14.137, 15.773, 17.955, 20.376],
        boy: [13.466, 14.403, 15.809, 17.62, 19.545],
    },
    100: {
        girl: [13.095, 14.162, 15.806, 18.004, 20.449],
        boy: [13.482, 14.421, 15.834, 17.659, 19.605],
    },
    101: {
        girl: [13.116, 14.187, 15.839, 18.053, 20.522],
        boy: [13.497, 14.44, 15.86, 17.698, 19.666],
    },
    102: {
        girl: [13.137, 14.213, 15.874, 18.103, 20.597],
        boy: [13.513, 14.459, 15.886, 17.738, 19.727],
    },
    103: {
        girl: [13.159, 14.239, 15.909, 18.154, 20.672],
        boy: [13.529, 14.478, 15.912, 17.778, 19.789],
    },
    104: {
        girl: [13.182, 14.266, 15.945, 18.206, 20.748],
        boy: [13.545, 14.497, 15.938, 17.818, 19.852],
    },
    105: {
        girl: [13.206, 14.294, 15.982, 18.259, 20.826],
        boy: [13.562, 14.517, 15.965, 17.86, 19.916],
    },
    106: {
        girl: [13.23, 14.323, 16.019, 18.313, 20.904],
        boy: [13.579, 14.537, 15.992, 17.902, 19.981],
    },
    107: {
        girl: [13.254, 14.352, 16.058, 18.367, 20.983],
        boy: [13.596, 14.558, 16.02, 17.944, 20.046],
    },
    108: {
        girl: [13.279, 14.382, 16.096, 18.422, 21.062],
        boy: [13.614, 14.579, 16.049, 17.987, 20.112],
    },
    109: {
        girl: [13.305, 14.412, 16.136, 18.478, 21.142],
        boy: [13.632, 14.6, 16.078, 18.031, 20.18],
    },
    110: {
        girl: [13.331, 14.443, 16.176, 18.535, 21.223],
        boy: [13.65, 14.622, 16.108, 18.076, 20.248],
    },
    111: {
        girl: [13.357, 14.474, 16.217, 18.592, 21.304],
        boy: [13.669, 14.645, 16.138, 18.121, 20.317],
    },
    112: {
        girl: [13.384, 14.506, 16.258, 18.65, 21.386],
        boy: [13.689, 14.668, 16.169, 18.168, 20.388],
    },
    113: {
        girl: [13.411, 14.538, 16.3, 18.708, 21.468],
        boy: [13.708, 14.691, 16.201, 18.215, 20.459],
    },
    114: {
        girl: [13.439, 14.571, 16.343, 18.767, 21.551],
        boy: [13.729, 14.716, 16.233, 18.263, 20.531],
    },
    115: {
        girl: [13.467, 14.605, 16.386, 18.827, 21.635],
        boy: [13.75, 14.741, 16.266, 18.311, 20.605],
    },
    116: {
        girl: [13.496, 14.639, 16.43, 18.887, 21.719],
        boy: [13.771, 14.766, 16.3, 18.361, 20.679],
    },
    117: {
        girl: [13.525, 14.674, 16.475, 18.949, 21.804],
        boy: [13.794, 14.793, 16.335, 18.412, 20.754],
    },
    118: {
        girl: [13.555, 14.709, 16.52, 19.011, 21.889],
        boy: [13.816, 14.82, 16.37, 18.462, 20.83],
    },
    119: {
        girl: [13.585, 14.745, 16.566, 19.074, 21.976],
        boy: [13.84, 14.847, 16.406, 18.515, 20.907],
    },
    120: {
        girl: [13.616, 14.782, 16.613, 19.137, 22.063],
        boy: [13.863, 14.875, 16.443, 18.568, 20.985],
    },
    121: {
        girl: [13.648, 14.819, 16.661, 19.202, 22.151],
        boy: [13.888, 14.904, 16.481, 18.621, 21.063],
    },
    122: {
        girl: [13.681, 14.858, 16.71, 19.267, 22.239],
        boy: [13.913, 14.933, 16.519, 18.675, 21.142],
    },
    123: {
        girl: [13.714, 14.897, 16.76, 19.334, 22.328],
        boy: [13.938, 14.963, 16.558, 18.73, 21.223],
    },
    124: {
        girl: [13.747, 14.937, 16.81, 19.401, 22.418],
        boy: [13.964, 14.994, 16.597, 18.786, 21.304],
    },
    125: {
        girl: [13.782, 14.977, 16.861, 19.469, 22.509],
        boy: [13.99, 15.025, 16.638, 18.843, 21.385],
    },
    126: {
        girl: [13.817, 15.019, 16.914, 19.538, 22.601],
        boy: [14.017, 15.056, 16.679, 18.9, 21.468],
    },
    127: {
        girl: [13.852, 15.061, 16.967, 19.608, 22.693],
        boy: [14.045, 15.089, 16.72, 18.958, 21.551],
    },
    128: {
        girl: [13.889, 15.104, 17.021, 19.679, 22.786],
        boy: [14.073, 15.122, 16.763, 19.017, 21.635],
    },
    129: {
        girl: [13.926, 15.147, 17.076, 19.751, 22.88],
        boy: [14.102, 15.156, 16.806, 19.077, 21.72],
    },
    130: {
        girl: [13.964, 15.192, 17.132, 19.824, 22.975],
        boy: [14.131, 15.19, 16.85, 19.137, 21.805],
    },
    131: {
        girl: [14.002, 15.237, 17.188, 19.898, 23.07],
        boy: [14.161, 15.225, 16.894, 19.198, 21.891],
    },
    132: {
        girl: [14.041, 15.283, 17.246, 19.973, 23.167],
        boy: [14.191, 15.26, 16.939, 19.26, 21.977],
    },
    133: {
        girl: [14.081, 15.33, 17.304, 20.048, 23.264],
        boy: [14.222, 15.296, 16.985, 19.322, 22.064],
    },
    134: {
        girl: [14.122, 15.378, 17.364, 20.125, 23.361],
        boy: [14.253, 15.333, 17.031, 19.385, 22.151],
    },
    135: {
        girl: [14.163, 15.426, 17.424, 20.202, 23.459],
        boy: [14.285, 15.37, 17.078, 19.449, 22.239],
    },
    136: {
        girl: [14.205, 15.475, 17.485, 20.28, 23.558],
        boy: [14.317, 15.408, 17.126, 19.513, 22.327],
    },
    137: {
        girl: [14.247, 15.525, 17.546, 20.359, 23.658],
        boy: [14.35, 15.447, 17.175, 19.578, 22.416],
    },
    138: {
        girl: [14.29, 15.575, 17.609, 20.439, 23.758],
        boy: [14.383, 15.486, 17.224, 19.643, 22.505],
    },
    139: {
        girl: [14.333, 15.626, 17.672, 20.519, 23.858],
        boy: [14.417, 15.525, 17.273, 19.71, 22.595],
    },
    140: {
        girl: [14.377, 15.678, 17.736, 20.6, 23.959],
        boy: [14.452, 15.566, 17.324, 19.777, 22.685],
    },
    141: {
        girl: [14.422, 15.73, 17.8, 20.682, 24.061],
        boy: [14.487, 15.607, 17.375, 19.844, 22.775],
    },
    142: {
        girl: [14.467, 15.782, 17.865, 20.764, 24.162],
        boy: [14.523, 15.648, 17.427, 19.913, 22.866],
    },
    143: {
        girl: [14.512, 15.836, 17.931, 20.846, 24.264],
        boy: [14.559, 15.691, 17.48, 19.982, 22.958],
    },
    144: {
        girl: [14.558, 15.889, 17.997, 20.929, 24.366],
        boy: [14.596, 15.734, 17.533, 20.052, 23.05],
    },
    145: {
        girl: [14.604, 15.943, 18.063, 21.013, 24.469],
        boy: [14.634, 15.778, 17.588, 20.122, 23.142],
    },
    146: {
        girl: [14.65, 15.997, 18.13, 21.096, 24.571],
        boy: [14.672, 15.822, 17.643, 20.193, 23.235],
    },
    147: {
        girl: [14.696, 16.052, 18.197, 21.18, 24.673],
        boy: [14.711, 15.867, 17.698, 20.265, 23.328],
    },
    148: {
        girl: [14.743, 16.106, 18.264, 21.264, 24.775],
        boy: [14.751, 15.913, 17.755, 20.338, 23.422],
    },
    149: {
        girl: [14.79, 16.161, 18.331, 21.348, 24.876],
        boy: [14.791, 15.96, 17.812, 20.411, 23.516],
    },
    150: {
        girl: [14.836, 16.216, 18.399, 21.432, 24.978],
        boy: [14.831, 16.007, 17.87, 20.486, 23.61],
    },
    151: {
        girl: [14.883, 16.271, 18.466, 21.516, 25.079],
        boy: [14.873, 16.055, 17.929, 20.56, 23.705],
    },
    152: {
        girl: [14.93, 16.325, 18.533, 21.6, 25.179],
        boy: [14.915, 16.103, 17.989, 20.636, 23.8],
    },
    153: {
        girl: [14.976, 16.38, 18.601, 21.683, 25.279],
        boy: [14.957, 16.153, 18.049, 20.711, 23.895],
    },
    154: {
        girl: [15.023, 16.435, 18.668, 21.766, 25.378],
        boy: [15, 16.202, 18.11, 20.788, 23.991],
    },
    155: {
        girl: [15.069, 16.489, 18.735, 21.849, 25.477],
        boy: [15.044, 16.253, 18.171, 20.865, 24.086],
    },
    156: {
        girl: [15.115, 16.544, 18.801, 21.931, 25.574],
        boy: [15.087, 16.303, 18.233, 20.943, 24.182],
    },
    157: {
        girl: [15.161, 16.598, 18.868, 22.013, 25.671],
        boy: [15.132, 16.355, 18.296, 21.021, 24.278],
    },
    158: {
        girl: [15.207, 16.651, 18.934, 22.094, 25.767],
        boy: [15.177, 16.407, 18.359, 21.099, 24.373],
    },
    159: {
        girl: [15.252, 16.705, 18.999, 22.175, 25.862],
        boy: [15.222, 16.459, 18.422, 21.178, 24.47],
    },
    160: {
        girl: [15.297, 16.758, 19.064, 22.255, 25.956],
        boy: [15.268, 16.512, 18.486, 21.257, 24.565],
    },
    161: {
        girl: [15.341, 16.81, 19.129, 22.335, 26.05],
        boy: [15.313, 16.565, 18.55, 21.336, 24.66],
    },
    162: {
        girl: [15.386, 16.862, 19.193, 22.413, 26.141],
        boy: [15.36, 16.618, 18.615, 21.416, 24.755],
    },
    163: {
        girl: [15.429, 16.914, 19.257, 22.491, 26.232],
        boy: [15.406, 16.672, 18.68, 21.495, 24.85],
    },
    164: {
        girl: [15.472, 16.965, 19.32, 22.569, 26.322],
        boy: [15.452, 16.726, 18.744, 21.574, 24.944],
    },
    165: {
        girl: [15.515, 17.016, 19.382, 22.645, 26.41],
        boy: [15.499, 16.779, 18.81, 21.654, 25.037],
    },
    166: {
        girl: [15.557, 17.066, 19.444, 22.72, 26.497],
        boy: [15.545, 16.833, 18.875, 21.733, 25.131],
    },
    167: {
        girl: [15.599, 17.115, 19.504, 22.795, 26.583],
        boy: [15.592, 16.887, 18.94, 21.812, 25.223],
    },
    168: {
        girl: [15.64, 17.164, 19.565, 22.868, 26.667],
        boy: [15.639, 16.941, 19.005, 21.891, 25.315],
    },
    169: {
        girl: [15.68, 17.212, 19.624, 22.94, 26.75],
        boy: [15.685, 16.995, 19.07, 21.97, 25.406],
    },
    170: {
        girl: [15.72, 17.259, 19.682, 23.012, 26.832],
        boy: [15.731, 17.049, 19.135, 22.049, 25.496],
    },
    171: {
        girl: [15.759, 17.306, 19.74, 23.082, 26.912],
        boy: [15.778, 17.103, 19.2, 22.127, 25.586],
    },
    172: {
        girl: [15.797, 17.352, 19.797, 23.151, 26.991],
        boy: [15.824, 17.157, 19.265, 22.204, 25.674],
    },
    173: {
        girl: [15.834, 17.397, 19.852, 23.219, 27.067],
        boy: [15.87, 17.21, 19.329, 22.282, 25.762],
    },
    174: {
        girl: [15.871, 17.441, 19.907, 23.285, 27.143],
        boy: [15.916, 17.264, 19.394, 22.359, 25.849],
    },
    175: {
        girl: [15.907, 17.484, 19.961, 23.35, 27.217],
        boy: [15.961, 17.317, 19.458, 22.436, 25.935],
    },
    176: {
        girl: [15.942, 17.527, 20.013, 23.414, 27.288],
        boy: [16.007, 17.37, 19.522, 22.512, 26.021],
    },
    177: {
        girl: [15.976, 17.568, 20.065, 23.477, 27.359],
        boy: [16.052, 17.423, 19.585, 22.587, 26.105],
    },
    178: {
        girl: [16.01, 17.609, 20.115, 23.538, 27.427],
        boy: [16.097, 17.475, 19.649, 22.663, 26.189],
    },
    179: {
        girl: [16.042, 17.648, 20.164, 23.598, 27.494],
        boy: [16.142, 17.528, 19.712, 22.737, 26.271],
    },
    180: {
        girl: [16.074, 17.687, 20.212, 23.656, 27.559],
        boy: [16.186, 17.58, 19.774, 22.812, 26.352],
    },
    181: {
        girl: [16.105, 17.724, 20.26, 23.713, 27.623],
        boy: [16.23, 17.631, 19.837, 22.885, 26.433],
    },
    182: {
        girl: [16.135, 17.761, 20.305, 23.768, 27.684],
        boy: [16.274, 17.683, 19.899, 22.958, 26.513],
    },
    183: {
        girl: [16.164, 17.796, 20.35, 23.822, 27.744],
        boy: [16.318, 17.734, 19.96, 23.031, 26.592],
    },
    184: {
        girl: [16.192, 17.831, 20.393, 23.875, 27.802],
        boy: [16.361, 17.784, 20.022, 23.103, 26.67],
    },
    185: {
        girl: [16.219, 17.864, 20.436, 23.926, 27.858],
        boy: [16.404, 17.835, 20.082, 23.174, 26.747],
    },
    186: {
        girl: [16.245, 17.897, 20.477, 23.976, 27.913],
        boy: [16.446, 17.885, 20.143, 23.245, 26.823],
    },
    187: {
        girl: [16.27, 17.928, 20.517, 24.025, 27.966],
        boy: [16.488, 17.935, 20.203, 23.315, 26.897],
    },
    188: {
        girl: [16.295, 17.959, 20.556, 24.072, 28.017],
        boy: [16.53, 17.984, 20.262, 23.385, 26.971],
    },
    189: {
        girl: [16.319, 17.989, 20.594, 24.117, 28.066],
        boy: [16.571, 18.032, 20.321, 23.453, 27.044],
    },
    190: {
        girl: [16.342, 18.018, 20.631, 24.162, 28.114],
        boy: [16.612, 18.081, 20.38, 23.522, 27.116],
    },
    191: {
        girl: [16.363, 18.045, 20.666, 24.205, 28.16],
        boy: [16.652, 18.129, 20.438, 23.589, 27.188],
    },
    192: {
        girl: [16.384, 18.072, 20.701, 24.247, 28.205],
        boy: [16.692, 18.176, 20.495, 23.656, 27.258],
    },
    193: {
        girl: [16.405, 18.098, 20.734, 24.287, 28.248],
        boy: [16.732, 18.223, 20.552, 23.722, 27.326],
    },
    194: {
        girl: [16.424, 18.123, 20.767, 24.326, 28.289],
        boy: [16.77, 18.27, 20.608, 23.787, 27.395],
    },
    195: {
        girl: [16.443, 18.148, 20.798, 24.364, 28.329],
        boy: [16.809, 18.316, 20.664, 23.852, 27.462],
    },
    196: {
        girl: [16.461, 18.171, 20.829, 24.4, 28.367],
        boy: [16.847, 18.361, 20.72, 23.916, 27.528],
    },
    197: {
        girl: [16.478, 18.193, 20.858, 24.436, 28.404],
        boy: [16.884, 18.406, 20.774, 23.979, 27.593],
    },
    198: {
        girl: [16.494, 18.215, 20.886, 24.47, 28.439],
        boy: [16.921, 18.451, 20.829, 24.042, 27.657],
    },
    199: {
        girl: [16.509, 18.235, 20.914, 24.503, 28.473],
        boy: [16.958, 18.495, 20.882, 24.104, 27.72],
    },
    200: {
        girl: [16.524, 18.255, 20.94, 24.535, 28.505],
        boy: [16.994, 18.538, 20.936, 24.165, 27.782],
    },
    201: {
        girl: [16.538, 18.274, 20.966, 24.565, 28.536],
        boy: [17.029, 18.581, 20.988, 24.226, 27.844],
    },
    202: {
        girl: [16.551, 18.292, 20.99, 24.595, 28.566],
        boy: [17.064, 18.624, 21.04, 24.285, 27.904],
    },
    203: {
        girl: [16.564, 18.31, 21.014, 24.623, 28.594],
        boy: [17.098, 18.666, 21.091, 24.344, 27.963],
    },
    204: {
        girl: [16.576, 18.327, 21.037, 24.651, 28.62],
        boy: [17.132, 18.707, 21.142, 24.402, 28.021],
    },
    205: {
        girl: [16.587, 18.343, 21.059, 24.677, 28.646],
        boy: [17.165, 18.748, 21.192, 24.46, 28.079],
    },
    206: {
        girl: [16.597, 18.358, 21.08, 24.703, 28.672],
        boy: [17.198, 18.788, 21.242, 24.517, 28.135],
    },
    207: {
        girl: [16.607, 18.373, 21.101, 24.727, 28.695],
        boy: [17.231, 18.828, 21.291, 24.573, 28.19],
    },
    208: {
        girl: [16.617, 18.388, 21.121, 24.751, 28.717],
        boy: [17.262, 18.868, 21.34, 24.628, 28.245],
    },
    209: {
        girl: [16.626, 18.401, 21.14, 24.774, 28.739],
        boy: [17.293, 18.906, 21.388, 24.683, 28.299],
    },
    210: {
        girl: [16.635, 18.414, 21.159, 24.796, 28.76],
        boy: [17.324, 18.944, 21.435, 24.737, 28.352],
    },
    211: {
        girl: [16.643, 18.427, 21.177, 24.818, 28.78],
        boy: [17.354, 18.982, 21.482, 24.79, 28.403],
    },
    212: {
        girl: [16.65, 18.439, 21.194, 24.839, 28.799],
        boy: [17.383, 19.019, 21.528, 24.843, 28.454],
    },
    213: {
        girl: [16.658, 18.451, 21.212, 24.859, 28.817],
        boy: [17.412, 19.056, 21.574, 24.895, 28.504],
    },
    214: {
        girl: [16.665, 18.463, 21.228, 24.879, 28.835],
        boy: [17.441, 19.092, 21.619, 24.946, 28.552],
    },
    215: {
        girl: [16.671, 18.474, 21.244, 24.898, 28.852],
        boy: [17.469, 19.128, 21.664, 24.996, 28.6],
    },
    216: {
        girl: [16.678, 18.485, 21.26, 24.917, 28.868],
        boy: [17.496, 19.163, 21.708, 25.046, 28.648],
    },
    217: {
        girl: [16.683, 18.495, 21.276, 24.936, 28.884],
        boy: [17.523, 19.197, 21.751, 25.094, 28.693],
    },
    218: {
        girl: [16.689, 18.505, 21.291, 24.953, 28.899],
        boy: [17.549, 19.231, 21.794, 25.143, 28.738],
    },
    219: {
        girl: [16.694, 18.515, 21.306, 24.971, 28.915],
        boy: [17.575, 19.264, 21.836, 25.19, 28.782],
    },
    220: {
        girl: [16.7, 18.524, 21.32, 24.988, 28.929],
        boy: [17.6, 19.297, 21.877, 25.237, 28.826],
    },
    221: {
        girl: [16.705, 18.534, 21.334, 25.004, 28.942],
        boy: [17.624, 19.329, 21.918, 25.282, 28.868],
    },
    222: {
        girl: [16.709, 18.543, 21.348, 25.021, 28.956],
        boy: [17.648, 19.361, 21.958, 25.328, 28.91],
    },
    223: {
        girl: [16.714, 18.552, 21.362, 25.037, 28.969],
        boy: [17.671, 19.392, 21.998, 25.372, 28.95],
    },
    224: {
        girl: [16.718, 18.56, 21.375, 25.053, 28.982],
        boy: [17.694, 19.422, 22.037, 25.416, 28.99],
    },
    225: {
        girl: [16.722, 18.569, 21.388, 25.068, 28.995],
        boy: [17.716, 19.452, 22.076, 25.459, 29.028],
    },
    226: {
        girl: [16.726, 18.577, 21.401, 25.084, 29.007],
        boy: [17.738, 19.482, 22.114, 25.501, 29.067],
    },
    227: {
        girl: [16.73, 18.585, 21.414, 25.099, 29.019],
        boy: [17.759, 19.511, 22.151, 25.543, 29.103],
    },
    228: {
        girl: [16.734, 18.593, 21.427, 25.113, 29.03],
        boy: [17.779, 19.539, 22.188, 25.584, 29.14],
    },
}
export const weight = {
    0: { girl: [2.44, 2.779, 3.232, 3.729, 4.166], boy: [2.507, 2.865, 3.346, 3.878, 4.35] },
    1: { girl: [3.203, 3.612, 4.172, 4.802, 5.371], boy: [3.433, 3.866, 4.453, 5.105, 5.69] },
    2: { girl: [4.007, 4.481, 5.132, 5.866, 6.534], boy: [4.39, 4.892, 5.571, 6.324, 6.996] },
    3: { girl: [4.617, 5.14, 5.86, 6.676, 7.421], boy: [5.106, 5.654, 6.392, 7.208, 7.935] },
    4: { girl: [5.106, 5.668, 6.445, 7.329, 8.139], boy: [5.66, 6.242, 7.025, 7.89, 8.66] },
    5: { girl: [5.504, 6.1, 6.924, 7.866, 8.732], boy: [6.102, 6.715, 7.538, 8.447, 9.255] },
    6: { girl: [5.835, 6.459, 7.326, 8.318, 9.234], boy: [6.464, 7.104, 7.964, 8.914, 9.76] },
    7: { girl: [6.119, 6.769, 7.673, 8.713, 9.676], boy: [6.769, 7.434, 8.329, 9.319, 10.201] },
    8: { girl: [6.369, 7.042, 7.982, 9.066, 10.073], boy: [7.034, 7.722, 8.649, 9.676, 10.592] },
    9: { girl: [6.593, 7.288, 8.261, 9.386, 10.434], boy: [7.27, 7.98, 8.938, 9.999, 10.947] },
    10: { girl: [6.798, 7.514, 8.517, 9.682, 10.77], boy: [7.486, 8.217, 9.203, 10.298, 11.277] },
    11: { girl: [6.99, 7.726, 8.759, 9.96, 11.086], boy: [7.688, 8.439, 9.453, 10.58, 11.589] },
    12: { girl: [7.175, 7.93, 8.99, 10.227, 11.388], boy: [7.88, 8.65, 9.691, 10.85, 11.888] },
    13: { girl: [7.355, 8.128, 9.215, 10.486, 11.681], boy: [8.065, 8.853, 9.921, 11.11, 12.177] },
    14: { girl: [7.532, 8.322, 9.436, 10.738, 11.966], boy: [8.243, 9.05, 10.144, 11.364, 12.459] },
    15: { girl: [7.707, 8.514, 9.653, 10.987, 12.247], boy: [8.417, 9.242, 10.363, 11.613, 12.738] },
    16: { girl: [7.88, 8.704, 9.868, 11.233, 12.524], boy: [8.587, 9.431, 10.578, 11.859, 13.013] },
    17: { girl: [8.052, 8.893, 10.082, 11.478, 12.799], boy: [8.754, 9.617, 10.79, 12.103, 13.285] },
    18: { girl: [8.222, 9.08, 10.294, 11.721, 13.073], boy: [8.918, 9.8, 11, 12.344, 13.556] },
    19: { girl: [8.392, 9.266, 10.505, 11.963, 13.345], boy: [9.08, 9.981, 11.208, 12.583, 13.826] },
    20: { girl: [8.56, 9.452, 10.716, 12.205, 13.618], boy: [9.24, 10.16, 11.414, 12.822, 14.096] },
    21: { girl: [8.727, 9.637, 10.927, 12.447, 13.892], boy: [9.399, 10.338, 11.62, 13.061, 14.366] },
    22: { girl: [8.894, 9.822, 11.138, 12.691, 14.167], boy: [9.556, 10.515, 11.826, 13.3, 14.637] },
    23: { girl: [9.062, 10.007, 11.351, 12.936, 14.445], boy: [9.712, 10.691, 12.03, 13.538, 14.908] },
    24: { girl: [9.229, 10.193, 11.563, 13.182, 14.724], boy: [9.867, 10.866, 12.233, 13.776, 15.178] },
    25: { girl: [9.395, 10.378, 11.776, 13.428, 15.004], boy: [10.019, 11.038, 12.435, 14.012, 15.448] },
    26: { girl: [9.56, 10.562, 11.988, 13.674, 15.284], boy: [10.169, 11.208, 12.634, 14.246, 15.715] },
    27: { girl: [9.722, 10.743, 12.197, 13.919, 15.563], boy: [10.316, 11.375, 12.829, 14.476, 15.979] },
    28: { girl: [9.881, 10.921, 12.404, 14.161, 15.84], boy: [10.46, 11.538, 13.021, 14.703, 16.238] },
    29: { girl: [10.036, 11.096, 12.607, 14.4, 16.114], boy: [10.6, 11.698, 13.21, 14.925, 16.494] },
    30: { girl: [10.188, 11.267, 12.808, 14.636, 16.386], boy: [10.738, 11.855, 13.394, 15.144, 16.745] },
    31: { girl: [10.336, 11.436, 13.005, 14.869, 16.656], boy: [10.873, 12.009, 13.576, 15.359, 16.993] },
    32: { girl: [10.482, 11.601, 13.2, 15.101, 16.925], boy: [11.005, 12.16, 13.754, 15.571, 17.237] },
    33: { girl: [10.626, 11.765, 13.393, 15.332, 17.193], boy: [11.136, 12.309, 13.931, 15.78, 17.479] },
    34: { girl: [10.767, 11.927, 13.586, 15.562, 17.462], boy: [11.264, 12.456, 14.105, 15.987, 17.719] },
    35: { girl: [10.908, 12.088, 13.778, 15.794, 17.734], boy: [11.392, 12.602, 14.278, 16.193, 17.956] },
    36: { girl: [11.047, 12.248, 13.969, 16.026, 18.006], boy: [11.519, 12.747, 14.45, 16.398, 18.193] },
    37: { girl: [11.185, 12.407, 14.161, 16.258, 18.281], boy: [11.645, 12.891, 14.621, 16.602, 18.429] },
    38: { girl: [11.321, 12.565, 14.352, 16.491, 18.557], boy: [11.771, 13.035, 14.791, 16.805, 18.665] },
    39: { girl: [11.456, 12.722, 14.543, 16.725, 18.835], boy: [11.897, 13.179, 14.962, 17.009, 18.901] },
    40: { girl: [11.59, 12.878, 14.733, 16.959, 19.113], boy: [12.022, 13.322, 15.132, 17.212, 19.137] },
    41: { girl: [11.722, 13.033, 14.922, 17.192, 19.393], boy: [12.147, 13.466, 15.303, 17.416, 19.375] },
    42: { girl: [11.853, 13.186, 15.11, 17.425, 19.673], boy: [12.271, 13.608, 15.473, 17.621, 19.612] },
    43: { girl: [11.982, 13.338, 15.297, 17.658, 19.953], boy: [12.395, 13.751, 15.643, 17.825, 19.851] },
    44: { girl: [12.111, 13.49, 15.484, 17.891, 20.234], boy: [12.518, 13.893, 15.813, 18.03, 20.09] },
    45: { girl: [12.238, 13.64, 15.67, 18.123, 20.514], boy: [12.64, 14.034, 15.983, 18.235, 20.33] },
    46: { girl: [12.365, 13.79, 15.855, 18.355, 20.795], boy: [12.762, 14.175, 16.152, 18.44, 20.571] },
    47: { girl: [12.491, 13.939, 16.04, 18.586, 21.075], boy: [12.883, 14.315, 16.322, 18.646, 20.813] },
    48: { girl: [12.617, 14.088, 16.225, 18.818, 21.357], boy: [13.003, 14.455, 16.491, 18.852, 21.056] },
    49: { girl: [12.742, 14.236, 16.409, 19.05, 21.638], boy: [13.122, 14.594, 16.66, 19.058, 21.3] },
    50: { girl: [12.867, 14.385, 16.594, 19.282, 21.921], boy: [13.242, 14.733, 16.829, 19.265, 21.544] },
    51: { girl: [12.992, 14.533, 16.778, 19.514, 22.203], boy: [13.36, 14.872, 16.998, 19.472, 21.79] },
    52: { girl: [13.117, 14.681, 16.962, 19.746, 22.485], boy: [13.479, 15.011, 17.167, 19.68, 22.036] },
    53: { girl: [13.241, 14.828, 17.146, 19.977, 22.768], boy: [13.597, 15.149, 17.336, 19.888, 22.284] },
    54: { girl: [13.365, 14.975, 17.329, 20.208, 23.05], boy: [13.714, 15.287, 17.505, 20.096, 22.532] },
    55: { girl: [13.488, 15.121, 17.511, 20.438, 23.331], boy: [13.831, 15.424, 17.674, 20.305, 22.78] },
    56: { girl: [13.611, 15.266, 17.692, 20.667, 23.611], boy: [13.948, 15.562, 17.843, 20.513, 23.029] },
    57: { girl: [13.732, 15.41, 17.872, 20.896, 23.891], boy: [14.064, 15.698, 18.011, 20.721, 23.279] },
    58: { girl: [13.852, 15.554, 18.051, 21.123, 24.169], boy: [14.179, 15.835, 18.179, 20.93, 23.528] },
    59: { girl: [13.972, 15.696, 18.229, 21.349, 24.447], boy: [14.294, 15.97, 18.346, 21.138, 23.777] },
    60: { girl: [14.079, 15.823, 18.389, 21.552, 24.697], boy: [14.398, 16.092, 18.497, 21.325, 24.002] },
    61: { girl: [14.173, 15.821, 18.258, 21.288, 24.336], boy: [14.58, 16.204, 18.506, 21.212, 23.774] },
    62: { girl: [14.297, 15.965, 18.433, 21.506, 24.601], boy: [14.711, 16.352, 18.68, 21.423, 24.026] },
    63: {
        girl: [14.421, 16.108, 18.607, 21.723, 24.866],
        boy: [14.844, 16.501, 18.856, 21.636, 24.279],
    },
    64: {
        girl: [14.544, 16.25, 18.781, 21.941, 25.132],
        boy: [14.978, 16.652, 19.034, 21.851, 24.535],
    },
    65: {
        girl: [14.666, 16.392, 18.954, 22.158, 25.398],
        boy: [15.114, 16.804, 19.213, 22.068, 24.793],
    },
    66: {
        girl: [14.788, 16.534, 19.128, 22.375, 25.664],
        boy: [15.251, 16.957, 19.394, 22.286, 25.053],
    },
    67: {
        girl: [14.909, 16.675, 19.3, 22.591, 25.93],
        boy: [15.389, 17.113, 19.576, 22.507, 25.315],
    },
    68: {
        girl: [15.03, 16.815, 19.473, 22.808, 26.197],
        boy: [15.53, 17.27, 19.761, 22.729, 25.58],
    },
    69: {
        girl: [15.151, 16.956, 19.646, 23.026, 26.465],
        boy: [15.672, 17.428, 19.947, 22.954, 25.847],
    },
    70: {
        girl: [15.272, 17.096, 19.818, 23.243, 26.733],
        boy: [15.815, 17.588, 20.134, 23.18, 26.117],
    },
    71: {
        girl: [15.392, 17.236, 19.991, 23.461, 27.002],
        boy: [15.959, 17.749, 20.324, 23.408, 26.388],
    },
    72: {
        girl: [15.513, 17.377, 20.164, 23.68, 27.273],
        boy: [16.105, 17.912, 20.514, 23.637, 26.661],
    },
    73: {
        girl: [15.634, 17.518, 20.338, 23.9, 27.545],
        boy: [16.252, 18.076, 20.705, 23.868, 26.937],
    },
    74: {
        girl: [15.756, 17.66, 20.512, 24.121, 27.819],
        boy: [16.4, 18.24, 20.898, 24.101, 27.215],
    },
    75: {
        girl: [15.878, 17.803, 20.688, 24.344, 28.095],
        boy: [16.548, 18.406, 21.092, 24.335, 27.494],
    },
    76: {
        girl: [16.001, 17.947, 20.866, 24.569, 28.375],
        boy: [16.697, 18.572, 21.287, 24.571, 27.777],
    },
    77: {
        girl: [16.126, 18.092, 21.046, 24.797, 28.658],
        boy: [16.848, 18.739, 21.483, 24.809, 28.061],
    },
    78: {
        girl: [16.252, 18.239, 21.227, 25.028, 28.945],
        boy: [16.999, 18.908, 21.681, 25.048, 28.349],
    },
    79: {
        girl: [16.38, 18.388, 21.411, 25.261, 29.234],
        boy: [17.15, 19.077, 21.88, 25.29, 28.639],
    },
    80: {
        girl: [16.509, 18.539, 21.598, 25.498, 29.529],
        boy: [17.303, 19.247, 22.08, 25.533, 28.931],
    },
    81: {
        girl: [16.641, 18.693, 21.787, 25.738, 29.828],
        boy: [17.455, 19.418, 22.281, 25.778, 29.227],
    },
    82: {
        girl: [16.774, 18.848, 21.98, 25.982, 30.132],
        boy: [17.609, 19.59, 22.484, 26.025, 29.525],
    },
    83: {
        girl: [16.91, 19.007, 22.175, 26.231, 30.441],
        boy: [17.762, 19.762, 22.687, 26.273, 29.826],
    },
    84: {
        girl: [17.049, 19.168, 22.374, 26.483, 30.755],
        boy: [17.916, 19.935, 22.892, 26.524, 30.13],
    },
    85: {
        girl: [17.189, 19.332, 22.576, 26.74, 31.075],
        boy: [18.07, 20.108, 23.097, 26.776, 30.436],
    },
    86: {
        girl: [17.332, 19.499, 22.782, 27, 31.399],
        boy: [18.224, 20.281, 23.303, 27.03, 30.746],
    },
    87: {
        girl: [17.477, 19.668, 22.99, 27.265, 31.73],
        boy: [18.378, 20.455, 23.51, 27.286, 31.059],
    },
    88: {
        girl: [17.625, 19.84, 23.202, 27.535, 32.065],
        boy: [18.532, 20.629, 23.718, 27.543, 31.375],
    },
    89: {
        girl: [17.775, 20.014, 23.418, 27.808, 32.406],
        boy: [18.686, 20.803, 23.927, 27.803, 31.695],
    },
    90: {
        girl: [17.927, 20.192, 23.637, 28.086, 32.752],
        boy: [18.841, 20.978, 24.137, 28.065, 32.017],
    },
    91: {
        girl: [18.082, 20.372, 23.859, 28.368, 33.103],
        boy: [18.995, 21.153, 24.348, 28.328, 32.343],
    },
    92: {
        girl: [18.24, 20.556, 24.085, 28.655, 33.46],
        boy: [19.148, 21.328, 24.56, 28.594, 32.674],
    },
    93: {
        girl: [18.4, 20.742, 24.315, 28.946, 33.823],
        boy: [19.302, 21.504, 24.772, 28.862, 33.007],
    },
    94: {
        girl: [18.562, 20.931, 24.548, 29.242, 34.192],
        boy: [19.456, 21.679, 24.986, 29.132, 33.345],
    },
    95: {
        girl: [18.728, 21.124, 24.785, 29.543, 34.567],
        boy: [19.609, 21.855, 25.2, 29.405, 33.687],
    },
    96: {
        girl: [18.896, 21.319, 25.026, 29.849, 34.947],
        boy: [19.763, 22.031, 25.416, 29.68, 34.033],
    },
    97: {
        girl: [19.066, 21.518, 25.271, 30.159, 35.334],
        boy: [19.916, 22.208, 25.633, 29.957, 34.384],
    },
    98: {
        girl: [19.24, 21.72, 25.52, 30.474, 35.727],
        boy: [20.069, 22.385, 25.851, 30.238, 34.74],
    },
    99: {
        girl: [19.416, 21.925, 25.772, 30.794, 36.126],
        boy: [20.222, 22.562, 26.071, 30.52, 35.099],
    },
    100: {
        girl: [19.595, 22.133, 26.028, 31.119, 36.53],
        boy: [20.375, 22.74, 26.291, 30.806, 35.464],
    },
    101: {
        girl: [19.777, 22.345, 26.288, 31.448, 36.94],
        boy: [20.528, 22.918, 26.513, 31.093, 35.832],
    },
    102: {
        girl: [19.961, 22.559, 26.552, 31.782, 37.355],
        boy: [20.681, 23.096, 26.736, 31.384, 36.206],
    },
    103: {
        girl: [20.147, 22.776, 26.819, 32.121, 37.778],
        boy: [20.833, 23.275, 26.96, 31.678, 36.585],
    },
    104: {
        girl: [20.337, 22.996, 27.09, 32.463, 38.204],
        boy: [20.986, 23.454, 27.186, 31.974, 36.969],
    },
    105: {
        girl: [20.528, 23.219, 27.364, 32.81, 38.636],
        boy: [21.14, 23.635, 27.414, 32.274, 37.358],
    },
    106: {
        girl: [20.722, 23.444, 27.641, 33.161, 39.073],
        boy: [21.293, 23.816, 27.643, 32.578, 37.753],
    },
    107: {
        girl: [20.918, 23.672, 27.921, 33.516, 39.514],
        boy: [21.448, 23.998, 27.875, 32.885, 38.155],
    },
    108: {
        girl: [21.116, 23.902, 28.204, 33.874, 39.96],
        boy: [21.603, 24.182, 28.109, 33.196, 38.562],
    },
    109: {
        girl: [21.316, 24.135, 28.49, 34.237, 40.411],
        boy: [21.759, 24.368, 28.346, 33.512, 38.975],
    },
    110: {
        girl: [21.518, 24.37, 28.779, 34.603, 40.867],
        boy: [21.917, 24.555, 28.585, 33.832, 39.395],
    },
    111: {
        girl: [21.723, 24.607, 29.071, 34.972, 41.326],
        boy: [22.076, 24.744, 28.828, 34.155, 39.82],
    },
    112: {
        girl: [21.929, 24.847, 29.366, 35.346, 41.791],
        boy: [22.236, 24.936, 29.073, 34.484, 40.252],
    },
    113: {
        girl: [22.138, 25.09, 29.665, 35.723, 42.26],
        boy: [22.398, 25.129, 29.322, 34.817, 40.69],
    },
    114: {
        girl: [22.349, 25.336, 29.966, 36.104, 42.734],
        boy: [22.561, 25.325, 29.574, 35.155, 41.135],
    },
    115: {
        girl: [22.563, 25.584, 30.272, 36.49, 43.214],
        boy: [22.727, 25.523, 29.829, 35.497, 41.587],
    },
    116: {
        girl: [22.78, 25.836, 30.58, 36.881, 43.699],
        boy: [22.894, 25.724, 30.088, 35.844, 42.044],
    },
    117: {
        girl: [22.999, 26.091, 30.893, 37.275, 44.189],
        boy: [23.063, 25.927, 30.35, 36.197, 42.508],
    },
    118: {
        girl: [23.222, 26.349, 31.21, 37.676, 44.687],
        boy: [23.234, 26.133, 30.616, 36.554, 42.978],
    },
    119: {
        girl: [23.447, 26.611, 31.532, 38.081, 45.19],
        boy: [23.406, 26.341, 30.885, 36.916, 43.455],
    },
    120: {
        girl: [23.676, 26.877, 31.858, 38.493, 45.7],
        boy: [23.581, 26.551, 31.159, 37.283, 43.938],
    },
}
export const headCircu = {
    0: {
        girl: [31.651, 32.651, 33.879, 35.106, 36.106],
        boy: [32.073, 33.145, 34.462, 35.778, 36.851],
    },
    1: {
        girl: [34.311, 35.301, 36.516, 37.732, 38.722],
        boy: [35.048, 36.033, 37.244, 38.454, 39.439],
    },
    2: {
        girl: [35.978, 37.002, 38.258, 39.514, 40.538],
        boy: [36.929, 37.919, 39.135, 40.351, 41.341],
    },
    3: {
        girl: [37.222, 38.271, 39.559, 40.846, 41.895],
        boy: [38.318, 39.316, 40.541, 41.767, 42.765],
    },
    4: {
        girl: [38.239, 39.308, 40.621, 41.934, 43.003],
        boy: [39.426, 40.435, 41.673, 42.912, 43.92],
    },
    5: {
        girl: [39.086, 40.173, 41.507, 42.841, 43.927],
        boy: [40.336, 41.356, 42.608, 43.86, 44.879],
    },
    6: {
        girl: [39.8, 40.901, 42.252, 43.604, 44.705],
        boy: [41.088, 42.119, 43.385, 44.652, 45.683],
    },
    7: {
        girl: [40.406, 41.519, 42.885, 44.25, 45.363],
        boy: [41.716, 42.758, 44.037, 45.317, 46.359],
    },
    8: {
        girl: [40.923, 42.046, 43.424, 44.802, 45.925],
        boy: [42.243, 43.296, 44.588, 45.88, 46.933],
    },
    9: {
        girl: [41.368, 42.499, 43.887, 45.275, 46.406],
        boy: [42.691, 43.753, 45.057, 46.361, 47.423],
    },
    10: {
        girl: [41.754, 42.892, 44.288, 45.685, 46.822],
        boy: [43.077, 44.148, 45.462, 46.776, 47.847],
    },
    11: {
        girl: [42.093, 43.236, 44.64, 46.044, 47.188],
        boy: [43.41, 44.489, 45.813, 47.137, 48.216],
    },
    12: {
        girl: [42.394, 43.542, 44.952, 46.361, 47.509],
        boy: [43.701, 44.787, 46.12, 47.453, 48.539],
    },
    13: {
        girl: [42.662, 43.815, 45.229, 46.644, 47.797],
        boy: [43.958, 45.051, 46.392, 47.734, 48.827],
    },
    14: {
        girl: [42.904, 44.061, 45.48, 46.899, 48.056],
        boy: [44.188, 45.287, 46.636, 47.985, 49.084],
    },
    15: {
        girl: [43.125, 44.285, 45.708, 47.131, 48.29],
        boy: [44.396, 45.501, 46.857, 48.213, 49.319],
    },
    16: {
        girl: [43.328, 44.491, 45.918, 47.344, 48.507],
        boy: [44.586, 45.696, 47.059, 48.423, 49.533],
    },
    17: {
        girl: [43.517, 44.682, 46.112, 47.542, 48.707],
        boy: [44.76, 45.876, 47.247, 48.617, 49.733],
    },
    18: {
        girl: [43.695, 44.862, 46.295, 47.728, 48.895],
        boy: [44.923, 46.045, 47.422, 48.798, 49.92],
    },
    19: {
        girl: [43.864, 45.033, 46.469, 47.904, 49.073],
        boy: [45.077, 46.203, 47.586, 48.969, 50.096],
    },
    20: {
        girl: [44.025, 45.196, 46.634, 48.072, 49.243],
        boy: [45.222, 46.354, 47.743, 49.132, 50.263],
    },
    21: {
        girl: [44.179, 45.353, 46.793, 48.234, 49.407],
        boy: [45.36, 46.497, 47.892, 49.287, 50.424],
    },
    22: {
        girl: [44.329, 45.504, 46.947, 48.39, 49.565],
        boy: [45.492, 46.634, 48.035, 49.437, 50.578],
    },
    23: {
        girl: [44.474, 45.651, 47.096, 48.541, 49.718],
        boy: [45.618, 46.765, 48.172, 49.58, 50.726],
    },
    24: {
        girl: [44.613, 45.792, 47.24, 48.687, 49.866],
        boy: [45.739, 46.891, 48.304, 49.717, 50.869],
    },
    25: {
        girl: [44.749, 45.929, 47.378, 48.827, 50.008],
        boy: [45.855, 47.011, 48.43, 49.849, 51.005],
    },
    26: {
        girl: [44.878, 46.06, 47.512, 48.963, 50.145],
        boy: [45.965, 47.126, 48.552, 49.977, 51.138],
    },
    27: {
        girl: [45.003, 46.186, 47.64, 49.093, 50.277],
        boy: [46.072, 47.237, 48.668, 50.098, 51.263],
    },
    28: {
        girl: [45.122, 46.307, 47.762, 49.217, 50.402],
        boy: [46.173, 47.343, 48.779, 50.214, 51.384],
    },
    29: {
        girl: [45.236, 46.423, 47.879, 49.335, 50.522],
        boy: [46.269, 47.444, 48.885, 50.326, 51.501],
    },
    30: {
        girl: [45.345, 46.533, 47.99, 49.448, 50.636],
        boy: [46.362, 47.54, 48.987, 50.433, 51.611],
    },
    31: {
        girl: [45.449, 46.638, 48.097, 49.556, 50.745],
        boy: [46.45, 47.632, 49.084, 50.535, 51.717],
    },
    32: {
        girl: [45.548, 46.738, 48.198, 49.659, 50.849],
        boy: [46.534, 47.72, 49.176, 50.633, 51.819],
    },
    33: {
        girl: [45.643, 46.834, 48.295, 49.757, 50.948],
        boy: [46.614, 47.804, 49.265, 50.726, 51.916],
    },
    34: {
        girl: [45.733, 46.925, 48.388, 49.851, 51.043],
        boy: [46.691, 47.885, 49.35, 50.815, 52.009],
    },
    35: {
        girl: [45.821, 47.014, 48.477, 49.941, 51.133],
        boy: [46.764, 47.961, 49.431, 50.901, 52.099],
    },
    36: {
        girl: [45.905, 47.098, 48.563, 50.027, 51.22],
        boy: [46.834, 48.035, 49.509, 50.984, 52.185],
    },
    37: {
        girl: [45.985, 47.179, 48.645, 50.11, 51.304],
        boy: [46.901, 48.106, 49.584, 51.063, 52.267],
    },
    38: {
        girl: [46.063, 47.257, 48.724, 50.19, 51.385],
        boy: [46.966, 48.174, 49.656, 51.139, 52.347],
    },
    39: {
        girl: [46.137, 47.333, 48.8, 50.267, 51.463],
        boy: [47.028, 48.239, 49.726, 51.213, 52.424],
    },
    40: {
        girl: [46.21, 47.405, 48.873, 50.341, 51.537],
        boy: [47.088, 48.302, 49.793, 51.283, 52.497],
    },
    41: {
        girl: [46.279, 47.476, 48.944, 50.413, 51.609],
        boy: [47.146, 48.363, 49.857, 51.352, 52.569],
    },
    42: {
        girl: [46.347, 47.543, 49.013, 50.482, 51.678],
        boy: [47.202, 48.422, 49.92, 51.418, 52.638],
    },
    43: {
        girl: [46.412, 47.609, 49.079, 50.548, 51.745],
        boy: [47.255, 48.479, 49.98, 51.482, 52.706],
    },
    44: {
        girl: [46.475, 47.673, 49.143, 50.612, 51.81],
        boy: [47.308, 48.534, 50.039, 51.544, 52.77],
    },
    45: {
        girl: [46.535, 47.734, 49.204, 50.675, 51.873],
        boy: [47.358, 48.587, 50.095, 51.604, 52.832],
    },
    46: {
        girl: [46.595, 47.793, 49.265, 50.736, 51.934],
        boy: [47.407, 48.639, 50.15, 51.662, 52.893],
    },
    47: {
        girl: [46.653, 47.852, 49.323, 50.794, 51.993],
        boy: [47.454, 48.688, 50.203, 51.718, 52.953],
    },
    48: {
        girl: [46.709, 47.908, 49.38, 50.852, 52.051],
        boy: [47.499, 48.736, 50.255, 51.773, 53.01],
    },
    49: {
        girl: [46.764, 47.963, 49.435, 50.907, 52.106],
        boy: [47.544, 48.783, 50.304, 51.826, 53.065],
    },
    50: {
        girl: [46.817, 48.016, 49.489, 50.962, 52.161],
        boy: [47.586, 48.828, 50.353, 51.877, 53.119],
    },
    51: {
        girl: [46.869, 48.069, 49.542, 51.014, 52.214],
        boy: [47.628, 48.872, 50.4, 51.927, 53.172],
    },
    52: {
        girl: [46.92, 48.12, 49.593, 51.066, 52.267],
        boy: [47.669, 48.916, 50.446, 51.975, 53.222],
    },
    53: {
        girl: [46.971, 48.171, 49.644, 51.117, 52.317],
        boy: [47.709, 48.958, 50.49, 52.023, 53.272],
    },
    54: {
        girl: [47.019, 48.22, 49.693, 51.167, 52.367],
        boy: [47.747, 48.998, 50.534, 52.07, 53.321],
    },
    55: {
        girl: [47.067, 48.267, 49.741, 51.215, 52.416],
        boy: [47.785, 49.038, 50.577, 52.115, 53.368],
    },
    56: {
        girl: [47.114, 48.315, 49.789, 51.262, 52.463],
        boy: [47.821, 49.077, 50.618, 52.16, 53.415],
    },
    57: {
        girl: [47.16, 48.361, 49.835, 51.309, 52.51],
        boy: [47.858, 49.116, 50.66, 52.203, 53.461],
    },
    58: {
        girl: [47.205, 48.406, 49.881, 51.355, 52.556],
        boy: [47.894, 49.153, 50.7, 52.246, 53.506],
    },
    59: {
        girl: [47.249, 48.451, 49.925, 51.4, 52.602],
        boy: [47.928, 49.19, 50.74, 52.289, 53.551],
    },
    60: {
        girl: [47.289, 48.49, 49.965, 51.44, 52.642],
        boy: [47.96, 49.224, 50.775, 52.327, 53.59],
    },
}
